export default {
  fintCityNameWithCNum(num) {
    var cityN = {
      '110000': '北京市北京市',
      '110100': '北京市北京市',
      '110101': '北京市北京市',
      '110102': '北京市北京市',
      '110103': '北京市北京市',
      '110104': '北京市北京市',
      '110105': '北京市北京市',
      '110106': '北京市北京市',
      '110107': '北京市北京市',
      '110108': '北京市北京市',
      '110109': '北京市北京市',
      '110111': '北京市北京市',
      '110112': '北京市北京市',
      '110113': '北京市北京市',
      '110114': '北京市北京市',
      '110115': '北京市北京市',
      '110116': '北京市北京市',
      '110117': '北京市北京市',
      '110200': '北京市北京市',
      '110228': '北京市北京市',
      '110229': '北京市北京市',
      '120000': '天津市天津市',
      '120100': '天津市天津市',
      '120101': '天津市天津市',
      '120102': '天津市天津市',
      '120103': '天津市天津市',
      '120104': '天津市天津市',
      '120105': '天津市天津市',
      '120106': '天津市天津市',
      '120107': '天津市天津市',
      '120108': '天津市天津市',
      '120109': '天津市天津市',
      '120110': '天津市天津市',
      '120111': '天津市天津市',
      '120112': '天津市天津市',
      '120113': '天津市天津市',
      '120114': '天津市天津市',
      '120115': '天津市天津市',
      '120200': '天津市天津市',
      '120221': '天津市天津市',
      '120222': '天津市天津市',
      '120223': '天津市天津市',
      '120225': '天津市天津市',
      '130000': '河北省',
      '130100': '河北省石家庄市',
      '130101': '河北省石家庄市',
      '130102': '河北省石家庄市',
      '130103': '河北省石家庄市',
      '130104': '河北省石家庄市',
      '130105': '河北省石家庄市',
      '130107': '河北省石家庄市',
      '130108': '河北省石家庄市',
      '130121': '河北省石家庄市',
      '130123': '河北省石家庄市',
      '130124': '河北省石家庄市',
      '130125': '河北省石家庄市',
      '130126': '河北省石家庄市',
      '130127': '河北省石家庄市',
      '130128': '河北省石家庄市',
      '130129': '河北省石家庄市',
      '130130': '河北省石家庄市',
      '130131': '河北省石家庄市',
      '130132': '河北省石家庄市',
      '130133': '河北省石家庄市',
      '130181': '河北省石家庄市',
      '130182': '河北省石家庄市',
      '130183': '河北省石家庄市',
      '130184': '河北省石家庄市',
      '130185': '河北省石家庄市',
      '130200': '河北省唐山市',
      '130201': '河北省唐山市',
      '130202': '河北省唐山市',
      '130203': '河北省唐山市',
      '130204': '河北省唐山市',
      '130205': '河北省唐山市',
      '130207': '河北省唐山市',
      '130208': '河北省唐山市',
      '130223': '河北省唐山市',
      '130224': '河北省唐山市',
      '130225': '河北省唐山市',
      '130227': '河北省唐山市',
      '130229': '河北省唐山市',
      '130230': '河北省唐山市',
      '130281': '河北省唐山市',
      '130283': '河北省唐山市',
      '130300': '河北省秦皇岛市',
      '130301': '河北省秦皇岛市',
      '130302': '河北省秦皇岛市',
      '130303': '河北省秦皇岛市',
      '130304': '河北省秦皇岛市',
      '130321': '河北省秦皇岛市',
      '130322': '河北省秦皇岛市',
      '130323': '河北省秦皇岛市',
      '130324': '河北省秦皇岛市',
      '130400': '河北省邯郸市',
      '130401': '河北省邯郸市',
      '130402': '河北省邯郸市',
      '130403': '河北省邯郸市',
      '130404': '河北省邯郸市',
      '130406': '河北省邯郸市',
      '130421': '河北省邯郸市',
      '130423': '河北省邯郸市',
      '130424': '河北省邯郸市',
      '130425': '河北省邯郸市',
      '130426': '河北省邯郸市',
      '130427': '河北省邯郸市',
      '130428': '河北省邯郸市',
      '130429': '河北省邯郸市',
      '130430': '河北省邯郸市',
      '130431': '河北省邯郸市',
      '130432': '河北省邯郸市',
      '130433': '河北省邯郸市',
      '130434': '河北省邯郸市',
      '130435': '河北省邯郸市',
      '130481': '河北省邯郸市',
      '130500': '河北省邢台市',
      '130501': '河北省邢台市',
      '130502': '河北省邢台市',
      '130503': '河北省邢台市',
      '130521': '河北省邢台市',
      '130522': '河北省邢台市',
      '130523': '河北省邢台市',
      '130524': '河北省邢台市',
      '130525': '河北省邢台市',
      '130526': '河北省邢台市',
      '130527': '河北省邢台市',
      '130528': '河北省邢台市',
      '130529': '河北省邢台市',
      '130530': '河北省邢台市',
      '130531': '河北省邢台市',
      '130532': '河北省邢台市',
      '130533': '河北省邢台市',
      '130534': '河北省邢台市',
      '130535': '河北省邢台市',
      '130581': '河北省邢台市',
      '130582': '河北省邢台市',
      '130600': '河北省保定市',
      '130601': '河北省保定市',
      '130602': '河北省保定市',
      '130603': '河北省保定市',
      '130604': '河北省保定市',
      '130621': '河北省保定市',
      '130622': '河北省保定市',
      '130623': '河北省保定市',
      '130624': '河北省保定市',
      '130625': '河北省保定市',
      '130626': '河北省保定市',
      '130627': '河北省保定市',
      '130628': '河北省保定市',
      '130629': '河北省保定市',
      '130630': '河北省保定市',
      '130631': '河北省保定市',
      '130632': '河北省保定市',
      '130633': '河北省保定市',
      '130634': '河北省保定市',
      '130635': '河北省保定市',
      '130636': '河北省保定市',
      '130637': '河北省保定市',
      '130638': '河北省保定市',
      '130681': '河北省保定市',
      '130682': '河北省保定市',
      '130683': '河北省保定市',
      '130684': '河北省保定市',
      '130700': '河北省张家口市',
      '130701': '河北省张家口市',
      '130702': '河北省张家口市',
      '130703': '河北省张家口市',
      '130705': '河北省张家口市',
      '130706': '河北省张家口市',
      '130721': '河北省张家口市',
      '130722': '河北省张家口市',
      '130723': '河北省张家口市',
      '130724': '河北省张家口市',
      '130725': '河北省张家口市',
      '130726': '河北省张家口市',
      '130727': '河北省张家口市',
      '130728': '河北省张家口市',
      '130729': '河北省张家口市',
      '130730': '河北省张家口市',
      '130731': '河北省张家口市',
      '130732': '河北省张家口市',
      '130733': '河北省张家口市',
      '130800': '河北省承德市',
      '130801': '河北省承德市',
      '130802': '河北省承德市',
      '130803': '河北省承德市',
      '130804': '河北省承德市',
      '130821': '河北省承德市',
      '130822': '河北省承德市',
      '130823': '河北省承德市',
      '130824': '河北省承德市',
      '130825': '河北省承德市',
      '130826': '河北省承德市',
      '130827': '河北省承德市',
      '130828': '河北省承德市',
      '130900': '河北省沧州市',
      '130901': '河北省沧州市',
      '130902': '河北省沧州市',
      '130903': '河北省沧州市',
      '130921': '河北省沧州市',
      '130922': '河北省沧州市',
      '130923': '河北省沧州市',
      '130924': '河北省沧州市',
      '130925': '河北省沧州市',
      '130926': '河北省沧州市',
      '130927': '河北省沧州市',
      '130928': '河北省沧州市',
      '130929': '河北省沧州市',
      '130930': '河北省沧州市',
      '130981': '河北省沧州市',
      '130982': '河北省沧州市',
      '130983': '河北省沧州市',
      '130984': '河北省沧州市',
      '131000': '河北省廊坊市',
      '131001': '河北省廊坊市',
      '131002': '河北省廊坊市',
      '131003': '河北省廊坊市',
      '131022': '河北省廊坊市',
      '131023': '河北省廊坊市',
      '131024': '河北省廊坊市',
      '131025': '河北省廊坊市',
      '131026': '河北省廊坊市',
      '131028': '河北省廊坊市',
      '131081': '河北省廊坊市',
      '131082': '河北省廊坊市',
      '131100': '河北省衡水市',
      '131101': '河北省衡水市',
      '131102': '河北省衡水市',
      '131121': '河北省衡水市',
      '131122': '河北省衡水市',
      '131123': '河北省衡水市',
      '131124': '河北省衡水市',
      '131125': '河北省衡水市',
      '131126': '河北省衡水市',
      '131127': '河北省衡水市',
      '131128': '河北省衡水市',
      '131181': '河北省衡水市',
      '131182': '河北省衡水市',
      '140000': '山西省',
      '140100': '山西省太原市',
      '140101': '山西省太原市',
      '140105': '山西省太原市',
      '140106': '山西省太原市',
      '140107': '山西省太原市',
      '140108': '山西省太原市',
      '140109': '山西省太原市',
      '140110': '山西省太原市',
      '140121': '山西省太原市',
      '140122': '山西省太原市',
      '140123': '山西省太原市',
      '140181': '山西省太原市',
      '140200': '山西省大同市',
      '140201': '山西省大同市',
      '140202': '山西省大同市',
      '140203': '山西省大同市',
      '140211': '山西省大同市',
      '140212': '山西省大同市',
      '140221': '山西省大同市',
      '140222': '山西省大同市',
      '140223': '山西省大同市',
      '140224': '山西省大同市',
      '140225': '山西省大同市',
      '140226': '山西省大同市',
      '140227': '山西省大同市',
      '140300': '山西省阳泉市',
      '140301': '山西省阳泉市',
      '140302': '山西省阳泉市',
      '140303': '山西省阳泉市',
      '140311': '山西省阳泉市',
      '140321': '山西省阳泉市',
      '140322': '山西省阳泉市',
      '140400': '山西省长治市',
      '140401': '山西省长治市',
      '140402': '山西省长治市',
      '140411': '山西省长治市',
      '140421': '山西省长治市',
      '140423': '山西省长治市',
      '140424': '山西省长治市',
      '140425': '山西省长治市',
      '140426': '山西省长治市',
      '140427': '山西省长治市',
      '140428': '山西省长治市',
      '140429': '山西省长治市',
      '140430': '山西省长治市',
      '140431': '山西省长治市',
      '140481': '山西省长治市',
      '140500': '山西省晋城市',
      '140501': '山西省晋城市',
      '140502': '山西省晋城市',
      '140521': '山西省晋城市',
      '140522': '山西省晋城市',
      '140524': '山西省晋城市',
      '140525': '山西省晋城市',
      '140581': '山西省晋城市',
      '140600': '山西省朔州市',
      '140601': '山西省朔州市',
      '140602': '山西省朔州市',
      '140603': '山西省朔州市',
      '140621': '山西省朔州市',
      '140622': '山西省朔州市',
      '140623': '山西省朔州市',
      '140624': '山西省朔州市',
      '140700': '山西省晋中市',
      '140701': '山西省晋中市',
      '140702': '山西省晋中市',
      '140721': '山西省晋中市',
      '140722': '山西省晋中市',
      '140723': '山西省晋中市',
      '140724': '山西省晋中市',
      '140725': '山西省晋中市',
      '140726': '山西省晋中市',
      '140727': '山西省晋中市',
      '140728': '山西省晋中市',
      '140729': '山西省晋中市',
      '140781': '山西省晋中市',
      '140800': '山西省运城市',
      '140801': '山西省运城市',
      '140802': '山西省运城市',
      '140821': '山西省运城市',
      '140822': '山西省运城市',
      '140823': '山西省运城市',
      '140824': '山西省运城市',
      '140825': '山西省运城市',
      '140826': '山西省运城市',
      '140827': '山西省运城市',
      '140828': '山西省运城市',
      '140829': '山西省运城市',
      '140830': '山西省运城市',
      '140881': '山西省运城市',
      '140882': '山西省运城市',
      '140900': '山西省忻州市',
      '140901': '山西省忻州市',
      '140902': '山西省忻州市',
      '140921': '山西省忻州市',
      '140922': '山西省忻州市',
      '140923': '山西省忻州市',
      '140924': '山西省忻州市',
      '140925': '山西省忻州市',
      '140926': '山西省忻州市',
      '140927': '山西省忻州市',
      '140928': '山西省忻州市',
      '140929': '山西省忻州市',
      '140930': '山西省忻州市',
      '140931': '山西省忻州市',
      '140932': '山西省忻州市',
      '140981': '山西省忻州市',
      '141000': '山西省临汾市',
      '141001': '山西省临汾市',
      '141002': '山西省临汾市',
      '141021': '山西省临汾市',
      '141022': '山西省临汾市',
      '141023': '山西省临汾市',
      '141024': '山西省临汾市',
      '141025': '山西省临汾市',
      '141026': '山西省临汾市',
      '141027': '山西省临汾市',
      '141028': '山西省临汾市',
      '141029': '山西省临汾市',
      '141030': '山西省临汾市',
      '141031': '山西省临汾市',
      '141032': '山西省临汾市',
      '141033': '山西省临汾市',
      '141034': '山西省临汾市',
      '141081': '山西省临汾市',
      '141082': '山西省临汾市',
      '141100': '山西省吕梁市',
      '141101': '山西省吕梁市',
      '141102': '山西省吕梁市',
      '141121': '山西省吕梁市',
      '141122': '山西省吕梁市',
      '141123': '山西省吕梁市',
      '141124': '山西省吕梁市',
      '141125': '山西省吕梁市',
      '141126': '山西省吕梁市',
      '141127': '山西省吕梁市',
      '141128': '山西省吕梁市',
      '141129': '山西省吕梁市',
      '141130': '山西省吕梁市',
      '141181': '山西省吕梁市',
      '141182': '山西省吕梁市',
      '142200': '山西省忻州市',
      '142201': '山西省忻州市',
      '142202': '山西省忻州市',
      '142222': '山西省忻州市',
      '142223': '山西省忻州市',
      '142225': '山西省忻州市',
      '142226': '山西省忻州市',
      '142227': '山西省忻州市',
      '142228': '山西省忻州市',
      '142229': '山西省忻州市',
      '142230': '山西省忻州市',
      '142231': '山西省忻州市',
      '142232': '山西省忻州市',
      '142233': '山西省忻州市',
      '142234': '山西省忻州市',
      '142301': '山西省吕梁市',
      '142302': '山西省吕梁市',
      '142303': '山西省吕梁市',
      '142322': '山西省吕梁市',
      '142323': '山西省吕梁市',
      '142325': '山西省吕梁市',
      '142326': '山西省吕梁市',
      '142327': '山西省吕梁市',
      '142328': '山西省吕梁市',
      '142329': '山西省吕梁市',
      '142330': '山西省吕梁市',
      '142332': '山西省吕梁市',
      '142333': '山西省吕梁市',
      '142600': '山西省 临汾市',
      '142601': '山西省 临汾市',
      '142602': '山西省 临汾市',
      '142603': '山西省 临汾市',
      '142621': '山西省 临汾市',
      '142622': '山西省 临汾市',
      '142623': '山西省 临汾市',
      '142625': '山西省 临汾市',
      '142627': '山西省 临汾市',
      '142628': '山西省 临汾市',
      '142629': '山西省 临汾市',
      '142630': '山西省 临汾市',
      '142631': '山西省 临汾市',
      '142632': '山西省 临汾市',
      '142633': '山西省 临汾市',
      '142634': '山西省 临汾市',
      '142635': '山西省 临汾市',
      '142636': '山西省 临汾市',
      '142700': '山西省运城市',
      '142701': '山西省运城市',
      '142702': '山西省运城市',
      '142703': '山西省运城市',
      '142723': '山西省运城市',
      '142724': '山西省运城市',
      '142725': '山西省运城市',
      '142726': '山西省运城市',
      '142727': '山西省运城市',
      '142729': '山西省运城市',
      '142730': '山西省运城市',
      '142731': '山西省运城市',
      '142732': '山西省运城市',
      '142733': '山西省运城市',
      '150000': '内蒙古自治区',
      '150100': '内蒙古自治区呼和浩特市',
      '150101': '内蒙古自治区呼和浩特市',
      '150102': '内蒙古自治区呼和浩特市',
      '150103': '内蒙古自治区呼和浩特市',
      '150104': '内蒙古自治区呼和浩特市',
      '150105': '内蒙古自治区呼和浩特市',
      '150121': '内蒙古自治区呼和浩特市',
      '150122': '内蒙古自治区呼和浩特市',
      '150123': '内蒙古自治区呼和浩特市',
      '150124': '内蒙古自治区呼和浩特市',
      '150125': '内蒙古自治区呼和浩特市',
      '150200': '内蒙古自治区包头市',
      '150201': '内蒙古自治区包头市',
      '150202': '内蒙古自治区包头市',
      '150203': '内蒙古自治区包头市',
      '150204': '内蒙古自治区包头市',
      '150205': '内蒙古自治区包头市',
      '150206': '内蒙古自治区包头市',
      '150207': '内蒙古自治区包头市',
      '150221': '内蒙古自治区包头市',
      '150222': '内蒙古自治区包头市',
      '150223': '内蒙古自治区包头市',
      '150300': '内蒙古自治区乌海市',
      '150301': '内蒙古自治区乌海市',
      '150302': '内蒙古自治区乌海市',
      '150303': '内蒙古自治区乌海市',
      '150304': '内蒙古自治区乌海市',
      '150400': '内蒙古自治区赤峰市',
      '150401': '内蒙古自治区赤峰市',
      '150402': '内蒙古自治区赤峰市',
      '150403': '内蒙古自治区赤峰市',
      '150404': '内蒙古自治区赤峰市',
      '150421': '内蒙古自治区赤峰市',
      '150422': '内蒙古自治区赤峰市',
      '150423': '内蒙古自治区赤峰市',
      '150424': '内蒙古自治区赤峰市',
      '150425': '内蒙古自治区赤峰市',
      '150426': '内蒙古自治区赤峰市',
      '150428': '内蒙古自治区赤峰市',
      '150429': '内蒙古自治区赤峰市',
      '150430': '内蒙古自治区赤峰市',
      '150500': '内蒙古自治区通辽市',
      '150501': '内蒙古自治区通辽市',
      '150502': '内蒙古自治区通辽市',
      '150521': '内蒙古自治区通辽市',
      '150522': '内蒙古自治区通辽市',
      '150523': '内蒙古自治区通辽市',
      '150524': '内蒙古自治区通辽市',
      '150525': '内蒙古自治区通辽市',
      '150526': '内蒙古自治区通辽市',
      '150581': '内蒙古自治区通辽市',
      '150600': '内蒙古自治区鄂尔多斯市',
      '150602': '内蒙古自治区鄂尔多斯市',
      '150621': '内蒙古自治区鄂尔多斯市',
      '150622': '内蒙古自治区鄂尔多斯市',
      '150623': '内蒙古自治区鄂尔多斯市',
      '150624': '内蒙古自治区鄂尔多斯市',
      '150625': '内蒙古自治区鄂尔多斯市',
      '150626': '内蒙古自治区鄂尔多斯市',
      '150627': '内蒙古自治区鄂尔多斯市',
      '150700': '内蒙古自治区呼伦贝尔市',
      '150701': '内蒙古自治区呼伦贝尔市',
      '150702': '内蒙古自治区呼伦贝尔市',
      '150721': '内蒙古自治区呼伦贝尔市',
      '150722': '内蒙古自治区呼伦贝尔市',
      '150723': '内蒙古自治区呼伦贝尔市',
      '150724': '内蒙古自治区呼伦贝尔市',
      '150725': '内蒙古自治区呼伦贝尔市',
      '150726': '内蒙古自治区呼伦贝尔市',
      '150727': '内蒙古自治区呼伦贝尔市',
      '150781': '内蒙古自治区呼伦贝尔市',
      '150782': '内蒙古自治区呼伦贝尔市',
      '150783': '内蒙古自治区呼伦贝尔市',
      '150784': '内蒙古自治区呼伦贝尔市',
      '150785': '内蒙古自治区呼伦贝尔市',
      '150800': '内蒙古自治区巴彦淖尔市',
      '150801': '内蒙古自治区巴彦淖尔市',
      '150802': '内蒙古自治区巴彦淖尔市',
      '150821': '内蒙古自治区巴彦淖尔市',
      '150822': '内蒙古自治区巴彦淖尔市',
      '150823': '内蒙古自治区巴彦淖尔市',
      '150824': '内蒙古自治区巴彦淖尔市',
      '150825': '内蒙古自治区巴彦淖尔市',
      '150826': '内蒙古自治区巴彦淖尔市',
      '150900': '内蒙古自治区乌兰察布市',
      '150901': '内蒙古自治区乌兰察布市',
      '150902': '内蒙古自治区乌兰察布市',
      '150921': '内蒙古自治区乌兰察布市',
      '150922': '内蒙古自治区乌兰察布市',
      '150923': '内蒙古自治区乌兰察布市',
      '150924': '内蒙古自治区乌兰察布市',
      '150925': '内蒙古自治区乌兰察布市',
      '150926': '内蒙古自治区乌兰察布市',
      '150927': '内蒙古自治区乌兰察布市',
      '150928': '内蒙古自治区乌兰察布市',
      '150929': '内蒙古自治区乌兰察布市',
      '150981': '内蒙古自治区乌兰察布市',
      '152200': '内蒙古自治区兴安盟',
      '152201': '内蒙古自治区兴安盟',
      '152202': '内蒙古自治区兴安盟',
      '152221': '内蒙古自治区兴安盟',
      '152222': '内蒙古自治区兴安盟',
      '152223': '内蒙古自治区兴安盟',
      '152224': '内蒙古自治区兴安盟',
      '152500': '内蒙古自治区锡林郭勒盟',
      '152501': '内蒙古自治区锡林郭勒盟',
      '152502': '内蒙古自治区锡林郭勒盟',
      '152522': '内蒙古自治区锡林郭勒盟',
      '152523': '内蒙古自治区锡林郭勒盟',
      '152524': '内蒙古自治区锡林郭勒盟',
      '152525': '内蒙古自治区锡林郭勒盟',
      '152526': '内蒙古自治区锡林郭勒盟',
      '152527': '内蒙古自治区锡林郭勒盟',
      '152528': '内蒙古自治区锡林郭勒盟',
      '152529': '内蒙古自治区锡林郭勒盟',
      '152530': '内蒙古自治区锡林郭勒盟',
      '152531': '内蒙古自治区锡林郭勒盟',
      '152600': '内蒙古自治区乌兰察布盟',
      '152601': '内蒙古自治区乌兰察布盟',
      '152602': '内蒙古自治区乌兰察布盟',
      '152624': '内蒙古自治区乌兰察布盟',
      '152625': '内蒙古自治区乌兰察布盟',
      '152626': '内蒙古自治区乌兰察布盟',
      '152627': '内蒙古自治区乌兰察布盟',
      '152629': '内蒙古自治区乌兰察布盟',
      '152630': '内蒙古自治区',
      '152631': '内蒙古自治区',
      '152632': '内蒙古自治区',
      '152634': '内蒙古自治区',
      '152800': '内蒙古自治区',
      '152801': '内蒙古自治区',
      '152822': '内蒙古自治区',
      '152823': '内蒙古自治区',
      '152824': '内蒙古自治区',
      '152825': '内蒙古自治区',
      '152826': '内蒙古自治区',
      '152827': '内蒙古自治区',
      '152900': '内蒙古自治区阿拉善盟',
      '152921': '内蒙古自治区阿拉善盟',
      '152922': '内蒙古自治区阿拉善盟',
      '152923': '内蒙古自治区阿拉善盟',
      '210000': '辽宁省',
      '210100': '辽宁省沈阳市',
      '210101': '辽宁省沈阳市',
      '210102': '辽宁省沈阳市',
      '210103': '辽宁省沈阳市',
      '210104': '辽宁省沈阳市',
      '210105': '辽宁省沈阳市',
      '210106': '辽宁省沈阳市',
      '210111': '辽宁省沈阳市',
      '210112': '辽宁省沈阳市',
      '210113': '辽宁省沈阳市',
      '210114': '辽宁省沈阳市',
      '210122': '辽宁省沈阳市',
      '210123': '辽宁省沈阳市',
      '210124': '辽宁省沈阳市',
      '210181': '辽宁省沈阳市',
      '210200': '辽宁省大连市',
      '210201': '辽宁省大连市',
      '210202': '辽宁省大连市',
      '210203': '辽宁省大连市',
      '210204': '辽宁省大连市',
      '210211': '辽宁省大连市',
      '210212': '辽宁省大连市',
      '210213': '辽宁省大连市',
      '210224': '辽宁省大连市',
      '210281': '辽宁省大连市',
      '210282': '辽宁省大连市',
      '210283': '辽宁省大连市',
      '210300': '辽宁省鞍山市',
      '210301': '辽宁省鞍山市',
      '210302': '辽宁省鞍山市',
      '210303': '辽宁省鞍山市',
      '210304': '辽宁省鞍山市',
      '210311': '辽宁省鞍山市',
      '210321': '辽宁省鞍山市',
      '210323': '辽宁省鞍山市',
      '210381': '辽宁省鞍山市',
      '210400': '辽宁省抚顺市',
      '210401': '辽宁省抚顺市',
      '210402': '辽宁省抚顺市',
      '210403': '辽宁省抚顺市',
      '210404': '辽宁省抚顺市',
      '210411': '辽宁省抚顺市',
      '210421': '辽宁省抚顺市',
      '210422': '辽宁省抚顺市',
      '210423': '辽宁省抚顺市',
      '210500': '辽宁省本溪市',
      '210501': '辽宁省本溪市',
      '210502': '辽宁省本溪市',
      '210503': '辽宁省本溪市',
      '210504': '辽宁省本溪市',
      '210505': '辽宁省本溪市',
      '210521': '辽宁省本溪市',
      '210522': '辽宁省本溪市',
      '210600': '辽宁省丹东市',
      '210601': '辽宁省丹东市',
      '210602': '辽宁省丹东市',
      '210603': '辽宁省丹东市',
      '210604': '辽宁省丹东市',
      '210624': '辽宁省丹东市',
      '210681': '辽宁省丹东市',
      '210682': '辽宁省丹东市',
      '210700': '辽宁省锦州市',
      '210701': '辽宁省锦州市',
      '210702': '辽宁省锦州市',
      '210703': '辽宁省锦州市',
      '210711': '辽宁省锦州市',
      '210726': '辽宁省锦州市',
      '210727': '辽宁省锦州市',
      '210781': '辽宁省锦州市',
      '210782': '辽宁省锦州市',
      '210800': '辽宁省营口市',
      '210801': '辽宁省营口市',
      '210802': '辽宁省营口市',
      '210803': '辽宁省营口市',
      '210804': '辽宁省营口市',
      '210811': '辽宁省营口市',
      '210881': '辽宁省营口市',
      '210882': '辽宁省营口市',
      '210900': '辽宁省阜新市',
      '210901': '辽宁省阜新市',
      '210902': '辽宁省阜新市',
      '210903': '辽宁省阜新市',
      '210904': '辽宁省阜新市',
      '210905': '辽宁省阜新市',
      '210911': '辽宁省阜新市',
      '210921': '辽宁省阜新市',
      '210922': '辽宁省阜新市',
      '211000': '辽宁省辽阳市',
      '211001': '辽宁省辽阳市',
      '211002': '辽宁省辽阳市',
      '211003': '辽宁省辽阳市',
      '211004': '辽宁省辽阳市',
      '211005': '辽宁省辽阳市',
      '211011': '辽宁省辽阳市',
      '211021': '辽宁省辽阳市',
      '211081': '辽宁省辽阳市',
      '211100': '辽宁省盘锦市',
      '211101': '辽宁省盘锦市',
      '211102': '辽宁省盘锦市',
      '211103': '辽宁省盘锦市',
      '211121': '辽宁省盘锦市',
      '211122': '辽宁省盘锦市',
      '211200': '辽宁省铁岭市',
      '211201': '辽宁省铁岭市',
      '211202': '辽宁省铁岭市',
      '211204': '辽宁省铁岭市',
      '211221': '辽宁省铁岭市',
      '211223': '辽宁省铁岭市',
      '211224': '辽宁省铁岭市',
      '211281': '辽宁省铁岭市',
      '211282': '辽宁省铁岭市',
      '211300': '辽宁省朝阳市',
      '211301': '辽宁省朝阳市',
      '211302': '辽宁省朝阳市',
      '211303': '辽宁省朝阳市',
      '211321': '辽宁省朝阳市',
      '211322': '辽宁省朝阳市',
      '211324': '辽宁省朝阳市',
      '211381': '辽宁省朝阳市',
      '211382': '辽宁省朝阳市',
      '211400': '辽宁省葫芦岛市',
      '211401': '辽宁省葫芦岛市',
      '211402': '辽宁省葫芦岛市',
      '211403': '辽宁省葫芦岛市',
      '211404': '辽宁省葫芦岛市',
      '211421': '辽宁省葫芦岛市',
      '211422': '辽宁省葫芦岛市',
      '211481': '辽宁省葫芦岛市',
      '220000': '吉林省',
      '220100': '吉林省长春市',
      '220101': '吉林省长春市',
      '220102': '吉林省长春市',
      '220103': '吉林省长春市',
      '220104': '吉林省长春市',
      '220105': '吉林省长春市',
      '220106': '吉林省长春市',
      '220112': '吉林省长春市',
      '220122': '吉林省长春市',
      '220181': '吉林省长春市',
      '220182': '吉林省长春市',
      '220183': '吉林省长春市',
      '220200': '吉林省吉林市',
      '220201': '吉林省吉林市',
      '220202': '吉林省吉林市',
      '220203': '吉林省吉林市',
      '220204': '吉林省吉林市',
      '220211': '吉林省吉林市',
      '220221': '吉林省吉林市',
      '220281': '吉林省吉林市',
      '220282': '吉林省吉林市',
      '220283': '吉林省吉林市',
      '220284': '吉林省吉林市',
      '220300': '吉林省四平市',
      '220301': '吉林省四平市',
      '220302': '吉林省四平市',
      '220303': '吉林省四平市',
      '220322': '吉林省四平市',
      '220323': '吉林省四平市',
      '220381': '吉林省四平市',
      '220382': '吉林省四平市',
      '220400': '吉林省辽源市',
      '220401': '吉林省辽源市',
      '220402': '吉林省辽源市',
      '220403': '吉林省辽源市',
      '220421': '吉林省辽源市',
      '220422': '吉林省辽源市',
      '220500': '吉林省通化市',
      '220501': '吉林省通化市',
      '220502': '吉林省通化市',
      '220503': '吉林省通化市',
      '220521': '吉林省通化市',
      '220523': '吉林省通化市',
      '220524': '吉林省通化市',
      '220581': '吉林省通化市',
      '220582': '吉林省通化市',
      '220600': '吉林省白山市',
      '220601': '吉林省白山市',
      '220602': '吉林省白山市',
      '220621': '吉林省白山市',
      '220622': '吉林省白山市',
      '220623': '吉林省白山市',
      '220625': '吉林省白山市',
      '220681': '吉林省白山市',
      '220700': '吉林省松原市',
      '220701': '吉林省松原市',
      '220702': '吉林省松原市',
      '220721': '吉林省松原市',
      '220722': '吉林省松原市',
      '220723': '吉林省松原市',
      '220724': '吉林省松原市',
      '220800': '吉林省白城市',
      '220801': '吉林省白城市',
      '220802': '吉林省白城市',
      '220821': '吉林省白城市',
      '220822': '吉林省白城市',
      '220881': '吉林省白城市',
      '220882': '吉林省白城市',
      '222400': '吉林省延边朝鲜族自治州',
      '222401': '吉林省延边朝鲜族自治州',
      '222402': '吉林省延边朝鲜族自治州',
      '222403': '吉林省延边朝鲜族自治州',
      '222404': '吉林省延边朝鲜族自治州',
      '222405': '吉林省延边朝鲜族自治州',
      '222406': '吉林省延边朝鲜族自治州',
      '222424': '吉林省延边朝鲜族自治州',
      '222426': '吉林省延边朝鲜族自治州',
      '230000': '黑龙江省',
      '230100': '黑龙江省哈尔滨市',
      '230101': '黑龙江省哈尔滨市',
      '230102': '黑龙江省哈尔滨市',
      '230103': '黑龙江省哈尔滨市',
      '230104': '黑龙江省哈尔滨市',
      '230105': '黑龙江省哈尔滨市',
      '230106': '黑龙江省哈尔滨市',
      '230107': '黑龙江省哈尔滨市',
      '230108': '黑龙江省哈尔滨市',
      '230109': '黑龙江省哈尔滨市',
      '230111': '黑龙江省哈尔滨市',
      '230121': '黑龙江省哈尔滨市',
      '230123': '黑龙江省哈尔滨市',
      '230124': '黑龙江省哈尔滨市',
      '230125': '黑龙江省哈尔滨市',
      '230126': '黑龙江省哈尔滨市',
      '230127': '黑龙江省哈尔滨市',
      '230128': '黑龙江省哈尔滨市',
      '230129': '黑龙江省哈尔滨市',
      '230181': '黑龙江省哈尔滨市',
      '230182': '黑龙江省哈尔滨市',
      '230183': '黑龙江省哈尔滨市',
      '230184': '黑龙江省哈尔滨市',
      '230200': '黑龙江省齐齐哈尔市',
      '230201': '黑龙江省齐齐哈尔市',
      '230202': '黑龙江省齐齐哈尔市',
      '230203': '黑龙江省齐齐哈尔市',
      '230204': '黑龙江省齐齐哈尔市',
      '230205': '黑龙江省齐齐哈尔市',
      '230206': '黑龙江省齐齐哈尔市',
      '230207': '黑龙江省齐齐哈尔市',
      '230208': '黑龙江省齐齐哈尔市',
      '230221': '黑龙江省齐齐哈尔市',
      '230223': '黑龙江省齐齐哈尔市',
      '230224': '黑龙江省齐齐哈尔市',
      '230225': '黑龙江省齐齐哈尔市',
      '230227': '黑龙江省齐齐哈尔市',
      '230229': '黑龙江省齐齐哈尔市',
      '230230': '黑龙江省齐齐哈尔市',
      '230231': '黑龙江省齐齐哈尔市',
      '230281': '黑龙江省齐齐哈尔市',
      '230300': '黑龙江省鸡西市',
      '230301': '黑龙江省鸡西市',
      '230302': '黑龙江省鸡西市',
      '230303': '黑龙江省鸡西市',
      '230304': '黑龙江省鸡西市',
      '230305': '黑龙江省鸡西市',
      '230306': '黑龙江省鸡西市',
      '230307': '黑龙江省鸡西市',
      '230321': '黑龙江省鸡西市',
      '230381': '黑龙江省鸡西市',
      '230382': '黑龙江省鸡西市',
      '230400': '黑龙江省鹤岗市',
      '230401': '黑龙江省鹤岗市',
      '230402': '黑龙江省鹤岗市',
      '230403': '黑龙江省鹤岗市',
      '230404': '黑龙江省鹤岗市',
      '230405': '黑龙江省鹤岗市',
      '230406': '黑龙江省鹤岗市',
      '230407': '黑龙江省鹤岗市',
      '230421': '黑龙江省鹤岗市',
      '230422': '黑龙江省鹤岗市',
      '230500': '黑龙江省双鸭山市',
      '230501': '黑龙江省双鸭山市',
      '230502': '黑龙江省双鸭山市',
      '230503': '黑龙江省双鸭山市',
      '230505': '黑龙江省双鸭山市',
      '230506': '黑龙江省双鸭山市',
      '230521': '黑龙江省双鸭山市',
      '230522': '黑龙江省双鸭山市',
      '230523': '黑龙江省双鸭山市',
      '230524': '黑龙江省双鸭山市',
      '230600': '黑龙江省大庆市',
      '230601': '黑龙江省大庆市',
      '230602': '黑龙江省大庆市',
      '230603': '黑龙江省大庆市',
      '230604': '黑龙江省大庆市',
      '230605': '黑龙江省大庆市',
      '230606': '黑龙江省大庆市',
      '230621': '黑龙江省大庆市',
      '230622': '黑龙江省大庆市',
      '230623': '黑龙江省大庆市',
      '230624': '黑龙江省大庆市',
      '230700': '黑龙江省伊春市',
      '230701': '黑龙江省伊春市',
      '230702': '黑龙江省伊春市',
      '230703': '黑龙江省伊春市',
      '230704': '黑龙江省伊春市',
      '230705': '黑龙江省伊春市',
      '230706': '黑龙江省伊春市',
      '230707': '黑龙江省伊春市',
      '230708': '黑龙江省伊春市',
      '230709': '黑龙江省伊春市',
      '230710': '黑龙江省伊春市',
      '230711': '黑龙江省伊春市',
      '230712': '黑龙江省伊春市',
      '230713': '黑龙江省伊春市',
      '230714': '黑龙江省伊春市',
      '230715': '黑龙江省伊春市',
      '230716': '黑龙江省伊春市',
      '230722': '黑龙江省伊春市',
      '230781': '黑龙江省伊春市',
      '230800': '黑龙江省佳木斯市',
      '230801': '黑龙江省佳木斯市',
      '230802': '黑龙江省佳木斯市',
      '230803': '黑龙江省佳木斯市',
      '230804': '黑龙江省佳木斯市',
      '230805': '黑龙江省佳木斯市',
      '230811': '黑龙江省佳木斯市',
      '230822': '黑龙江省佳木斯市',
      '230826': '黑龙江省佳木斯市',
      '230828': '黑龙江省佳木斯市',
      '230833': '黑龙江省佳木斯市',
      '230881': '黑龙江省佳木斯市',
      '230882': '黑龙江省佳木斯市',
      '230900': '黑龙江省七台河市',
      '230901': '黑龙江省七台河市',
      '230902': '黑龙江省七台河市',
      '230903': '黑龙江省七台河市',
      '230904': '黑龙江省七台河市',
      '230921': '黑龙江省七台河市',
      '231000': '黑龙江省牡丹江市',
      '231001': '黑龙江省牡丹江市',
      '231002': '黑龙江省牡丹江市',
      '231003': '黑龙江省牡丹江市',
      '231004': '黑龙江省牡丹江市',
      '231005': '黑龙江省牡丹江市',
      '231024': '黑龙江省牡丹江市',
      '231025': '黑龙江省牡丹江市',
      '231081': '黑龙江省牡丹江市',
      '231083': '黑龙江省牡丹江市',
      '231084': '黑龙江省牡丹江市',
      '231085': '黑龙江省牡丹江市',
      '231100': '黑龙江省黑河市',
      '231101': '黑龙江省黑河市',
      '231102': '黑龙江省黑河市',
      '231121': '黑龙江省黑河市',
      '231123': '黑龙江省黑河市',
      '231124': '黑龙江省黑河市',
      '231181': '黑龙江省黑河市',
      '231182': '黑龙江省黑河市',
      '231200': '黑龙江省绥化市',
      '231201': '黑龙江省绥化市',
      '231202': '黑龙江省绥化市',
      '231221': '黑龙江省绥化市',
      '231222': '黑龙江省绥化市',
      '231223': '黑龙江省绥化市',
      '231224': '黑龙江省绥化市',
      '231225': '黑龙江省绥化市',
      '231226': '黑龙江省绥化市',
      '231281': '黑龙江省绥化市',
      '231282': '黑龙江省绥化市',
      '231283': '黑龙江省绥化市',
      '232700': '黑龙江省大兴安岭地区',
      '232721': '黑龙江省大兴安岭地区',
      '232722': '黑龙江省大兴安岭地区',
      '232723': '黑龙江省大兴安岭地区',
      '310000': '上海市',
      '310100': '上海市上海市',
      '310101': '上海市上海市',
      '310102': '上海市上海市',
      '310103': '上海市上海市',
      '310104': '上海市上海市',
      '310105': '上海市上海市',
      '310106': '上海市上海市',
      '310107': '上海市上海市',
      '310108': '上海市上海市',
      '310109': '上海市上海市',
      '310110': '上海市上海市',
      '310112': '上海市上海市',
      '310113': '上海市上海市',
      '310114': '上海市上海市',
      '310115': '上海市上海市',
      '310116': '上海市上海市',
      '310117': '上海市上海市',
      '310118': '上海市上海市',
      '310119': '上海市上海市',
      '310120': '上海市上海市',
      '310200': '上海市上海市',
      '310230': '上海市上海市',
      '320000': '江苏省',
      '320100': '江苏省南京市',
      '320101': '江苏省南京市',
      '320102': '江苏省南京市',
      '320103': '江苏省南京市',
      '320104': '江苏省南京市',
      '320105': '江苏省南京市',
      '320106': '江苏省南京市',
      '320107': '江苏省南京市',
      '320111': '江苏省南京市',
      '320113': '江苏省南京市',
      '320114': '江苏省南京市',
      '320115': '江苏省南京市',
      '320116': '江苏省南京市',
      '320124': '江苏省南京市',
      '320125': '江苏省南京市',
      '320200': '江苏省无锡市',
      '320201': '江苏省无锡市',
      '320202': '江苏省无锡市',
      '320203': '江苏省无锡市',
      '320204': '江苏省无锡市',
      '320205': '江苏省无锡市',
      '320206': '江苏省无锡市',
      '320211': '江苏省无锡市',
      '320281': '江苏省无锡市',
      '320282': '江苏省无锡市',
      '320300': '江苏省徐州市',
      '320301': '江苏省徐州市',
      '320302': '江苏省徐州市',
      '320303': '江苏省徐州市',
      '320304': '江苏省徐州市',
      '320305': '江苏省徐州市',
      '320311': '江苏省徐州市',
      '320321': '江苏省徐州市',
      '320322': '江苏省徐州市',
      '320323': '江苏省徐州市',
      '320324': '江苏省徐州市',
      '320381': '江苏省徐州市',
      '320382': '江苏省徐州市',
      '320400': '江苏省常州市',
      '320401': '江苏省常州市',
      '320402': '江苏省常州市',
      '320404': '江苏省常州市',
      '320405': '江苏省常州市',
      '320411': '江苏省常州市',
      '320412': '江苏省常州市',
      '320481': '江苏省常州市',
      '320482': '江苏省常州市',
      '320500': '江苏省苏州市',
      '320501': '江苏省苏州市',
      '320502': '江苏省苏州市',
      '320503': '江苏省苏州市',
      '320504': '江苏省苏州市',
      '320505': '江苏省苏州市',
      '320506': '江苏省苏州市',
      '320507': '江苏省苏州市',
      '320511': '江苏省苏州市',
      '320581': '江苏省苏州市',
      '320582': '江苏省苏州市',
      '320583': '江苏省苏州市',
      '320584': '江苏省苏州市',
      '320585': '江苏省苏州市',
      '320600': '江苏省南通市',
      '320601': '江苏省南通市',
      '320602': '江苏省南通市',
      '320611': '江苏省南通市',
      '320621': '江苏省南通市',
      '320623': '江苏省南通市',
      '320681': '江苏省南通市',
      '320682': '江苏省南通市',
      '320683': '江苏省南通市',
      '320684': '江苏省南通市',
      '320700': '江苏省连云港市',
      '320701': '江苏省连云港市',
      '320703': '江苏省连云港市',
      '320705': '江苏省连云港市',
      '320706': '江苏省连云港市',
      '320721': '江苏省连云港市',
      '320722': '江苏省连云港市',
      '320723': '江苏省连云港市',
      '320724': '江苏省连云港市',
      '320800': '江苏省淮安市',
      '320801': '江苏省淮安市',
      '320802': '江苏省淮安市',
      '320803': '江苏省淮安市',
      '320804': '江苏省淮安市',
      '320811': '江苏省淮安市',
      '320826': '江苏省淮安市',
      '320829': '江苏省淮安市',
      '320830': '江苏省淮安市',
      '320831': '江苏省淮安市',
      '320900': '江苏省盐城市',
      '320901': '江苏省盐城市',
      '320902': '江苏省盐城市',
      '320903': '江苏省盐城市',
      '320921': '江苏省盐城市',
      '320922': '江苏省盐城市',
      '320923': '江苏省盐城市',
      '320924': '江苏省盐城市',
      '320925': '江苏省盐城市',
      '320928': '江苏省盐城市',
      '320981': '江苏省盐城市',
      '320982': '江苏省盐城市',
      '321000': '江苏省扬州市',
      '321001': '江苏省扬州市',
      '321002': '江苏省扬州市',
      '321003': '江苏省扬州市',
      '321011': '江苏省扬州市',
      '321023': '江苏省扬州市',
      '321081': '江苏省扬州市',
      '321084': '江苏省扬州市',
      '321088': '江苏省扬州市',
      '321100': '江苏省镇江市',
      '321101': '江苏省镇江市',
      '321102': '江苏省镇江市',
      '321111': '江苏省镇江市',
      '321112': '江苏省镇江市',
      '321181': '江苏省镇江市',
      '321182': '江苏省镇江市',
      '321183': '江苏省镇江市',
      '321200': '江苏省泰州市',
      '321201': '江苏省泰州市',
      '321202': '江苏省泰州市',
      '321203': '江苏省泰州市',
      '321281': '江苏省泰州市',
      '321282': '江苏省泰州市',
      '321283': '江苏省泰州市',
      '321284': '江苏省泰州市',
      '321300': '江苏省宿迁市',
      '321301': '江苏省宿迁市',
      '321302': '江苏省宿迁市',
      '321311': '江苏省宿迁市',
      '321321': '江苏省宿迁市',
      '321322': '江苏省宿迁市',
      '321323': '江苏省宿迁市',
      '321324': '江苏省宿迁市',
      '330000': '浙江省',
      '330100': '浙江省杭州市',
      '330101': '浙江省杭州市',
      '330102': '浙江省杭州市',
      '330103': '浙江省杭州市',
      '330104': '浙江省杭州市',
      '330105': '浙江省杭州市',
      '330106': '浙江省杭州市',
      '330108': '浙江省杭州市',
      '330109': '浙江省杭州市',
      '330110': '浙江省杭州市',
      '330122': '浙江省杭州市',
      '330127': '浙江省杭州市',
      '330182': '浙江省杭州市',
      '330183': '浙江省杭州市',
      '330185': '浙江省杭州市',
      '330200': '浙江省宁波市',
      '330201': '浙江省宁波市',
      '330203': '浙江省宁波市',
      '330204': '浙江省宁波市',
      '330205': '浙江省宁波市',
      '330206': '浙江省宁波市',
      '330211': '浙江省宁波市',
      '330212': '浙江省宁波市',
      '330225': '浙江省宁波市',
      '330226': '浙江省宁波市',
      '330281': '浙江省宁波市',
      '330282': '浙江省宁波市',
      '330283': '浙江省宁波市',
      '330300': '浙江省温州市',
      '330301': '浙江省温州市',
      '330302': '浙江省温州市',
      '330303': '浙江省温州市',
      '330304': '浙江省温州市',
      '330322': '浙江省温州市',
      '330324': '浙江省温州市',
      '330326': '浙江省温州市',
      '330327': '浙江省温州市',
      '330328': '浙江省温州市',
      '330329': '浙江省温州市',
      '330381': '浙江省温州市',
      '330382': '浙江省温州市',
      '330400': '浙江省嘉兴市',
      '330401': '浙江省嘉兴市',
      '330402': '浙江省嘉兴市',
      '330411': '浙江省嘉兴市',
      '330421': '浙江省嘉兴市',
      '330424': '浙江省嘉兴市',
      '330481': '浙江省嘉兴市',
      '330482': '浙江省嘉兴市',
      '330483': '浙江省嘉兴市',
      '330500': '浙江省湖州市',
      '330501': '浙江省湖州市',
      '330502': '浙江省湖州市',
      '330503': '浙江省湖州市',
      '330521': '浙江省湖州市',
      '330522': '浙江省湖州市',
      '330523': '浙江省湖州市',
      '330600': '浙江省绍兴市',
      '330601': '浙江省绍兴市',
      '330602': '浙江省绍兴市',
      '330621': '浙江省绍兴市',
      '330624': '浙江省绍兴市',
      '330681': '浙江省绍兴市',
      '330682': '浙江省绍兴市',
      '330683': '浙江省绍兴市',
      '330700': '浙江省金华市',
      '330701': '浙江省金华市',
      '330702': '浙江省金华市',
      '330703': '浙江省金华市',
      '330723': '浙江省金华市',
      '330726': '浙江省金华市',
      '330727': '浙江省金华市',
      '330781': '浙江省金华市',
      '330782': '浙江省金华市',
      '330783': '浙江省金华市',
      '330784': '浙江省金华市',
      '330800': '浙江省衢州市',
      '330801': '浙江省衢州市',
      '330802': '浙江省衢州市',
      '330803': '浙江省衢州市',
      '330822': '浙江省衢州市',
      '330824': '浙江省衢州市',
      '330825': '浙江省衢州市',
      '330881': '浙江省衢州市',
      '330900': '浙江省舟山市',
      '330901': '浙江省舟山市',
      '330902': '浙江省舟山市',
      '330903': '浙江省舟山市',
      '330921': '浙江省舟山市',
      '330922': '浙江省舟山市',
      '331000': '浙江省台州市',
      '331001': '浙江省台州市',
      '331002': '浙江省台州市',
      '331003': '浙江省台州市',
      '331004': '浙江省台州市',
      '331021': '浙江省台州市',
      '331022': '浙江省台州市',
      '331023': '浙江省台州市',
      '331024': '浙江省台州市',
      '331081': '浙江省台州市',
      '331082': '浙江省台州市',
      '331100': '浙江省丽水市',
      '331101': '浙江省丽水市',
      '331102': '浙江省丽水市',
      '331121': '浙江省丽水市',
      '331122': '浙江省丽水市',
      '331123': '浙江省丽水市',
      '331124': '浙江省丽水市',
      '331125': '浙江省丽水市',
      '331126': '浙江省丽水市',
      '331127': '浙江省丽水市',
      '331181': '浙江省丽水市',
      '332500': '浙江省丽水市',
      '332501': '浙江省丽水市',
      '332502': '浙江省丽水市',
      '332522': '浙江省丽水市',
      '332523': '浙江省丽水市',
      '332525': '浙江省丽水市',
      '332526': '浙江省丽水市',
      '332527': '浙江省丽水市',
      '332528': '浙江省丽水市',
      '332529': '浙江省丽水市',
      '340000': '安徽省',
      '340100': '安徽省合肥市',
      '340101': '安徽省合肥市',
      '340102': '安徽省合肥市',
      '340103': '安徽省合肥市',
      '340104': '安徽省合肥市',
      '340111': '安徽省合肥市',
      '340121': '安徽省合肥市',
      '340122': '安徽省合肥市',
      '340123': '安徽省合肥市',
      '340200': '安徽省芜湖市',
      '340201': '安徽省芜湖市',
      '340202': '安徽省芜湖市',
      '340203': '安徽省芜湖市',
      '340204': '安徽省芜湖市',
      '340207': '安徽省芜湖市',
      '340221': '安徽省芜湖市',
      '340222': '安徽省芜湖市',
      '340223': '安徽省芜湖市',
      '340300': '安徽省蚌埠市',
      '340301': '安徽省蚌埠市',
      '340302': '安徽省蚌埠市',
      '340303': '安徽省蚌埠市',
      '340304': '安徽省蚌埠市',
      '340311': '安徽省蚌埠市',
      '340321': '安徽省蚌埠市',
      '340322': '安徽省蚌埠市',
      '340323': '安徽省蚌埠市',
      '340400': '安徽省淮南市',
      '340401': '安徽省淮南市',
      '340402': '安徽省淮南市',
      '340403': '安徽省淮南市',
      '340404': '安徽省淮南市',
      '340405': '安徽省淮南市',
      '340406': '安徽省淮南市',
      '340421': '安徽省淮南市',
      '340500': '安徽省马鞍山市',
      '340501': '安徽省马鞍山市',
      '340502': '安徽省马鞍山市',
      '340503': '安徽省马鞍山市',
      '340504': '安徽省马鞍山市',
      '340521': '安徽省马鞍山市',
      '340600': '安徽省淮北市',
      '340601': '安徽省淮北市',
      '340602': '安徽省淮北市',
      '340603': '安徽省淮北市',
      '340604': '安徽省淮北市',
      '340621': '安徽省淮北市',
      '340700': '安徽省铜陵市',
      '340701': '安徽省铜陵市',
      '340702': '安徽省铜陵市',
      '340703': '安徽省铜陵市',
      '340711': '安徽省铜陵市',
      '340721': '安徽省铜陵市',
      '340800': '安徽省安庆市',
      '340801': '安徽省安庆市',
      '340802': '安徽省安庆市',
      '340803': '安徽省安庆市',
      '340811': '安徽省安庆市',
      '340822': '安徽省安庆市',
      '340823': '安徽省安庆市',
      '340824': '安徽省安庆市',
      '340825': '安徽省安庆市',
      '340826': '安徽省安庆市',
      '340827': '安徽省安庆市',
      '340828': '安徽省安庆市',
      '340881': '安徽省安庆市',
      '341000': '安徽省黄山市',
      '341001': '安徽省黄山市',
      '341002': '安徽省黄山市',
      '341003': '安徽省黄山市',
      '341004': '安徽省黄山市',
      '341021': '安徽省黄山市',
      '341022': '安徽省黄山市',
      '341023': '安徽省黄山市',
      '341024': '安徽省黄山市',
      '341100': '安徽省滁州市',
      '341101': '安徽省滁州市',
      '341102': '安徽省滁州市',
      '341103': '安徽省滁州市',
      '341122': '安徽省滁州市',
      '341124': '安徽省滁州市',
      '341125': '安徽省滁州市',
      '341126': '安徽省滁州市',
      '341181': '安徽省滁州市',
      '341182': '安徽省滁州市',
      '341200': '安徽省阜阳市',
      '341201': '安徽省阜阳市',
      '341202': '安徽省阜阳市',
      '341203': '安徽省阜阳市',
      '341204': '安徽省阜阳市',
      '341221': '安徽省阜阳市',
      '341222': '安徽省阜阳市',
      '341223': '安徽省阜阳市',
      '341224': '安徽省阜阳市',
      '341225': '安徽省阜阳市',
      '341226': '安徽省阜阳市',
      '341227': '安徽省阜阳市',
      '341281': '安徽省阜阳市',
      '341282': '安徽省阜阳市',
      '341300': '安徽省宿州市',
      '341301': '安徽省宿州市',
      '341302': '安徽省宿州市',
      '341321': '安徽省宿州市',
      '341322': '安徽省宿州市',
      '341323': '安徽省宿州市',
      '341324': '安徽省宿州市',
      '341400': '安徽省巢湖市',
      '341401': '安徽省巢湖市',
      '341402': '安徽省巢湖市',
      '341421': '安徽省巢湖市',
      '341422': '安徽省巢湖市',
      '341423': '安徽省巢湖市',
      '341424': '安徽省巢湖市',
      '341500': '安徽省六安市',
      '341501': '安徽省六安市',
      '341502': '安徽省六安市',
      '341503': '安徽省六安市',
      '341521': '安徽省六安市',
      '341522': '安徽省六安市',
      '341523': '安徽省六安市',
      '341524': '安徽省六安市',
      '341525': '安徽省六安市',
      '341600': '安徽省亳州市',
      '341601': '安徽省亳州市',
      '341602': '安徽省亳州市',
      '341621': '安徽省亳州市',
      '341622': '安徽省亳州市',
      '341623': '安徽省亳州市',
      '341700': '安徽省池州市',
      '341701': '安徽省池州市',
      '341702': '安徽省池州市',
      '341721': '安徽省池州市',
      '341722': '安徽省池州市',
      '341723': '安徽省池州市',
      '341800': '安徽省宣城市',
      '341801': '安徽省宣城市',
      '341802': '安徽省宣城市',
      '341821': '安徽省宣城市',
      '341822': '安徽省宣城市',
      '341823': '安徽省宣城市',
      '341824': '安徽省宣城市',
      '341825': '安徽省宣城市',
      '341881': '安徽省宣城市',
      '342500': '安徽省宣城市',
      '342501': '安徽省宣城市',
      '342502': '安徽省宣城市',
      '342522': '安徽省宣城市',
      '342523': '安徽省宣城市',
      '342529': '安徽省宣城市',
      '342530': '安徽省宣城市',
      '342531': '安徽省宣城市',
      '342900': '安徽省池州市',
      '342901': '安徽省池州市',
      '342921': '安徽省池州市',
      '342922': '安徽省池州市',
      '342923': '安徽省池州市',
      '350000': '福建省',
      '350100': '福建省福州市',
      '350101': '福建省福州市',
      '350102': '福建省福州市',
      '350103': '福建省福州市',
      '350104': '福建省福州市',
      '350105': '福建省福州市',
      '350111': '福建省福州市',
      '350121': '福建省福州市',
      '350122': '福建省福州市',
      '350123': '福建省福州市',
      '350124': '福建省福州市',
      '350125': '福建省福州市',
      '350128': '福建省福州市',
      '350181': '福建省福州市',
      '350182': '福建省福州市',
      '350200': '福建省厦门市',
      '350201': '福建省厦门市',
      '350202': '福建省厦门市',
      '350203': '福建省厦门市',
      '350204': '福建省厦门市',
      '350205': '福建省厦门市',
      '350206': '福建省厦门市',
      '350211': '福建省厦门市',
      '350212': '福建省厦门市',
      '350213': '福建省厦门市',
      '350300': '福建省莆田市',
      '350301': '福建省莆田市',
      '350302': '福建省莆田市',
      '350303': '福建省莆田市',
      '350304': '福建省莆田市',
      '350305': '福建省莆田市',
      '350322': '福建省莆田市',
      '350400': '福建省三明市',
      '350401': '福建省三明市',
      '350402': '福建省三明市',
      '350403': '福建省三明市',
      '350421': '福建省三明市',
      '350423': '福建省三明市',
      '350424': '福建省三明市',
      '350425': '福建省三明市',
      '350426': '福建省三明市',
      '350427': '福建省三明市',
      '350428': '福建省三明市',
      '350429': '福建省三明市',
      '350430': '福建省三明市',
      '350481': '福建省三明市',
      '350500': '福建省泉州市',
      '350501': '福建省泉州市',
      '350502': '福建省泉州市',
      '350503': '福建省泉州市',
      '350504': '福建省泉州市',
      '350505': '福建省泉州市',
      '350521': '福建省泉州市',
      '350524': '福建省泉州市',
      '350525': '福建省泉州市',
      '350526': '福建省泉州市',
      '350527': '福建省泉州市',
      '350581': '福建省泉州市',
      '350582': '福建省泉州市',
      '350583': '福建省泉州市',
      '350600': '福建省漳州市',
      '350601': '福建省漳州市',
      '350602': '福建省漳州市',
      '350603': '福建省漳州市',
      '350622': '福建省漳州市',
      '350623': '福建省漳州市',
      '350624': '福建省漳州市',
      '350625': '福建省漳州市',
      '350626': '福建省漳州市',
      '350627': '福建省漳州市',
      '350628': '福建省漳州市',
      '350629': '福建省漳州市',
      '350681': '福建省漳州市',
      '350700': '福建省漳州市',
      '350701': '福建省南平市',
      '350702': '福建省南平市',
      '350721': '福建省南平市',
      '350722': '福建省南平市',
      '350723': '福建省南平市',
      '350724': '福建省南平市',
      '350725': '福建省南平市',
      '350781': '福建省南平市',
      '350782': '福建省南平市',
      '350783': '福建省南平市',
      '350784': '福建省南平市',
      '350800': '福建省龙岩市',
      '350801': '福建省龙岩市',
      '350802': '福建省龙岩市',
      '350821': '福建省龙岩市',
      '350822': '福建省龙岩市',
      '350823': '福建省龙岩市',
      '350824': '福建省龙岩市',
      '350825': '福建省龙岩市',
      '350881': '福建省龙岩市',
      '350900': '福建省宁德市',
      '350901': '福建省宁德市',
      '350902': '福建省宁德市',
      '350921': '福建省宁德市',
      '350922': '福建省宁德市',
      '350923': '福建省宁德市',
      '350924': '福建省宁德市',
      '350925': '福建省宁德市',
      '350926': '福建省宁德市',
      '350981': '福建省宁德市',
      '350982': '福建省宁德市',
      '360000': '江西省',
      '360100': '江西省南昌市',
      '360101': '江西省南昌市',
      '360102': '江西省南昌市',
      '360103': '江西省南昌市',
      '360104': '江西省南昌市',
      '360105': '江西省南昌市',
      '360111': '江西省南昌市',
      '360121': '江西省南昌市',
      '360122': '江西省南昌市',
      '360123': '江西省南昌市',
      '360124': '江西省南昌市',
      '360200': '江西省景德镇市',
      '360201': '江西省景德镇市',
      '360202': '江西省景德镇市',
      '360203': '江西省景德镇市',
      '360222': '江西省景德镇市',
      '360281': '江西省景德镇市',
      '360300': '江西省萍乡市',
      '360301': '江西省萍乡市',
      '360302': '江西省萍乡市',
      '360313': '江西省萍乡市',
      '360321': '江西省萍乡市',
      '360322': '江西省萍乡市',
      '360323': '江西省萍乡市',
      '360400': '江西省九江市',
      '360401': '江西省九江市',
      '360402': '江西省九江市',
      '360403': '江西省九江市',
      '360421': '江西省九江市',
      '360423': '江西省九江市',
      '360424': '江西省九江市',
      '360425': '江西省九江市',
      '360426': '江西省九江市',
      '360427': '江西省九江市',
      '360428': '江西省九江市',
      '360429': '江西省九江市',
      '360430': '江西省九江市',
      '360481': '江西省九江市',
      '360500': '江西省新余市',
      '360501': '江西省新余市',
      '360502': '江西省新余市',
      '360521': '江西省新余市',
      '360600': '江西省鹰潭市',
      '360601': '江西省鹰潭市',
      '360602': '江西省鹰潭市',
      '360622': '江西省鹰潭市',
      '360681': '江西省鹰潭市',
      '360700': '江西省赣州市',
      '360701': '江西省赣州市',
      '360702': '江西省赣州市',
      '360721': '江西省赣州市',
      '360722': '江西省赣州市',
      '360723': '江西省赣州市',
      '360724': '江西省赣州市',
      '360725': '江西省赣州市',
      '360726': '江西省赣州市',
      '360727': '江西省赣州市',
      '360728': '江西省赣州市',
      '360729': '江西省赣州市',
      '360730': '江西省赣州市',
      '360731': '江西省赣州市',
      '360732': '江西省赣州市',
      '360733': '江西省赣州市',
      '360734': '江西省赣州市',
      '360735': '江西省赣州市',
      '360781': '江西省赣州市',
      '360782': '江西省赣州市',
      '360800': '江西省吉安市',
      '360801': '江西省吉安市',
      '360802': '江西省吉安市',
      '360803': '江西省吉安市',
      '360821': '江西省吉安市',
      '360822': '江西省吉安市',
      '360823': '江西省吉安市',
      '360824': '江西省吉安市',
      '360825': '江西省吉安市',
      '360826': '江西省吉安市',
      '360827': '江西省吉安市',
      '360828': '江西省吉安市',
      '360829': '江西省吉安市',
      '360830': '江西省吉安市',
      '360881': '江西省吉安市',
      '360900': '江西省宜春市',
      '360901': '江西省宜春市',
      '360902': '江西省宜春市',
      '360921': '江西省宜春市',
      '360922': '江西省宜春市',
      '360923': '江西省宜春市',
      '360924': '江西省宜春市',
      '360925': '江西省宜春市',
      '360926': '江西省宜春市',
      '360981': '江西省宜春市',
      '360982': '江西省宜春市',
      '360983': '江西省宜春市',
      '361000': '江西省抚州市',
      '361001': '江西省抚州市',
      '361002': '江西省抚州市',
      '361021': '江西省抚州市',
      '361022': '江西省抚州市',
      '361023': '江西省抚州市',
      '361024': '江西省抚州市',
      '361025': '江西省抚州市',
      '361026': '江西省抚州市',
      '361027': '江西省抚州市',
      '361028': '江西省抚州市',
      '361029': '江西省抚州市',
      '361030': '江西省抚州市',
      '361100': '江西省上饶市',
      '361101': '江西省上饶市',
      '361102': '江西省上饶市',
      '361121': '江西省上饶市',
      '361122': '江西省上饶市',
      '361123': '江西省上饶市',
      '361124': '江西省上饶市',
      '361125': '江西省上饶市',
      '361126': '江西省上饶市',
      '361127': '江西省上饶市',
      '361128': '江西省上饶市',
      '361129': '江西省上饶市',
      '361130': '江西省上饶市',
      '361181': '江西省上饶市',
      '362200': '江西省宜春',
      '362201': '江西省宜春',
      '362202': '江西省宜春',
      '362203': '江西省宜春',
      '362204': '江西省宜春',
      '362226': '江西省宜春',
      '362227': '江西省宜春',
      '362228': '江西省宜春',
      '362229': '江西省宜春',
      '362232': '江西省宜春',
      '362233': '江西省宜春',
      '362300': '江西省上饶市',
      '362301': '江西省上饶市',
      '362302': '江西省上饶市',
      '362321': '江西省上饶市',
      '362322': '江西省上饶市',
      '362323': '江西省上饶市',
      '362324': '江西省上饶市',
      '362325': '江西省上饶市',
      '362326': '江西省上饶市',
      '362329': '江西省上饶市',
      '362330': '江西省上饶市',
      '362331': '江西省上饶市',
      '362334': '江西省上饶市',
      '362400': '江西省吉安市',
      '362401': '江西省吉安市',
      '362402': '江西省吉安市',
      '362421': '江西省吉安市',
      '362422': '江西省吉安市',
      '362423': '江西省吉安市',
      '362424': '江西省吉安市',
      '362425': '江西省吉安市',
      '362426': '江西省吉安市',
      '362427': '江西省吉安市',
      '362428': '江西省吉安市',
      '362429': '江西省吉安市',
      '362430': '江西省吉安市',
      '362432': '江西省吉安市',
      '362500': '江西省抚州市',
      '362501': '江西省抚州市',
      '362522': '江西省抚州市',
      '362523': '江西省抚州市',
      '362524': '江西省抚州市',
      '362525': '江西省抚州市',
      '362526': '江西省抚州市',
      '362527': '江西省抚州市',
      '362528': '江西省抚州市',
      '362529': '江西省抚州市',
      '362531': '江西省抚州市',
      '362532': '江西省抚州市',
      '370000': '山东省',
      '370100': '山东省济南市',
      '370101': '山东省济南市',
      '370102': '山东省济南市',
      '370103': '山东省济南市',
      '370104': '山东省济南市',
      '370105': '山东省济南市',
      '370112': '山东省济南市',
      '370113': '山东省济南市',
      '370124': '山东省济南市',
      '370125': '山东省济南市',
      '370126': '山东省济南市',
      '370181': '山东省济南市',
      '370200': '山东省青岛市',
      '370201': '山东省青岛市',
      '370202': '山东省青岛市',
      '370203': '山东省青岛市',
      '370205': '山东省青岛市',
      '370211': '山东省青岛市',
      '370212': '山东省青岛市',
      '370213': '山东省青岛市',
      '370214': '山东省青岛市',
      '370281': '山东省青岛市',
      '370282': '山东省青岛市',
      '370283': '山东省青岛市',
      '370284': '山东省青岛市',
      '370285': '山东省青岛市',
      '370300': '山东省淄博市',
      '370301': '山东省淄博市',
      '370302': '山东省淄博市',
      '370303': '山东省淄博市',
      '370304': '山东省淄博市',
      '370305': '山东省淄博市',
      '370306': '山东省淄博市',
      '370321': '山东省淄博市',
      '370322': '山东省淄博市',
      '370323': '山东省淄博市',
      '370400': '山东省枣庄市',
      '370401': '山东省枣庄市',
      '370402': '山东省枣庄市',
      '370403': '山东省枣庄市',
      '370404': '山东省枣庄市',
      '370405': '山东省枣庄市',
      '370406': '山东省枣庄市',
      '370481': '山东省枣庄市',
      '370500': '山东省东营市',
      '370501': '山东省东营市',
      '370502': '山东省东营市',
      '370503': '山东省东营市',
      '370521': '山东省东营市',
      '370522': '山东省东营市',
      '370523': '山东省东营市',
      '370600': '山东省烟台市',
      '370601': '山东省烟台市',
      '370602': '山东省烟台市',
      '370611': '山东省烟台市',
      '370612': '山东省烟台市',
      '370613': '山东省烟台市',
      '370634': '山东省烟台市',
      '370681': '山东省烟台市',
      '370682': '山东省烟台市',
      '370683': '山东省烟台市',
      '370684': '山东省烟台市',
      '370685': '山东省烟台市',
      '370686': '山东省烟台市',
      '370687': '山东省烟台市',
      '370700': '山东省潍坊市',
      '370701': '山东省潍坊市',
      '370702': '山东省潍坊市',
      '370703': '山东省潍坊市',
      '370704': '山东省潍坊市',
      '370705': '山东省潍坊市',
      '370724': '山东省潍坊市',
      '370725': '山东省潍坊市',
      '370781': '山东省潍坊市',
      '370782': '山东省潍坊市',
      '370783': '山东省潍坊市',
      '370784': '山东省潍坊市',
      '370785': '山东省潍坊市',
      '370786': '山东省潍坊市',
      '370800': '山东省济宁市',
      '370801': '山东省济宁市',
      '370802': '山东省济宁市',
      '370811': '山东省济宁市',
      '370826': '山东省济宁市',
      '370827': '山东省济宁市',
      '370828': '山东省济宁市',
      '370829': '山东省济宁市',
      '370830': '山东省济宁市',
      '370831': '山东省济宁市',
      '370832': '山东省济宁市',
      '370881': '山东省济宁市',
      '370882': '山东省济宁市',
      '370883': '山东省济宁市',
      '370900': '山东省泰安市',
      '370901': '山东省泰安市',
      '370902': '山东省泰安市',
      '370903': '山东省泰安市',
      '370911': '山东省泰安市',
      '370921': '山东省泰安市',
      '370923': '山东省泰安市',
      '370982': '山东省泰安市',
      '370983': '山东省泰安市',
      '371000': '山东省威海市',
      '371001': '山东省威海市',
      '371002': '山东省威海市',
      '371081': '山东省威海市',
      '371082': '山东省威海市',
      '371083': '山东省威海市',
      '371100': '山东省日照市',
      '371101': '山东省日照市',
      '371102': '山东省日照市',
      '371103': '山东省日照市',
      '371121': '山东省日照市',
      '371122': '山东省日照市',
      '371200': '山东省莱芜市',
      '371201': '山东省莱芜市',
      '371202': '山东省莱芜市',
      '371203': '山东省莱芜市',
      '371300': '山东省临沂市',
      '371301': '山东省临沂市',
      '371302': '山东省临沂市',
      '371311': '山东省临沂市',
      '371312': '山东省临沂市',
      '371321': '山东省临沂市',
      '371322': '山东省临沂市',
      '371323': '山东省临沂市',
      '371324': '山东省临沂市',
      '371325': '山东省临沂市',
      '371326': '山东省临沂市',
      '371327': '山东省临沂市',
      '371328': '山东省临沂市',
      '371329': '山东省临沂市',
      '371400': '山东省德州市',
      '371401': '山东省德州市',
      '371402': '山东省德州市',
      '371421': '山东省德州市',
      '371422': '山东省德州市',
      '371423': '山东省德州市',
      '371424': '山东省德州市',
      '371425': '山东省德州市',
      '371426': '山东省德州市',
      '371427': '山东省德州市',
      '371428': '山东省德州市',
      '371481': '山东省德州市',
      '371482': '山东省德州市',
      '371500': '山东省聊城市',
      '371501': '山东省聊城市',
      '371502': '山东省聊城市',
      '371521': '山东省聊城市',
      '371522': '山东省聊城市',
      '371523': '山东省聊城市',
      '371524': '山东省聊城市',
      '371525': '山东省聊城市',
      '371526': '山东省聊城市',
      '371581': '山东省聊城市',
      '371600': '山东省滨州市',
      '371601': '山东省滨州市',
      '371602': '山东省滨州市',
      '371621': '山东省滨州市',
      '371622': '山东省滨州市',
      '371623': '山东省滨州市',
      '371624': '山东省滨州市',
      '371625': '山东省滨州市',
      '371626': '山东省滨州市',
      '371700': '山东省荷泽市',
      '371701': '山东省荷泽市',
      '371702': '山东省荷泽市',
      '371721': '山东省荷泽市',
      '371722': '山东省荷泽市',
      '371723': '山东省荷泽市',
      '371724': '山东省荷泽市',
      '371725': '山东省荷泽市',
      '371726': '山东省荷泽市',
      '371727': '山东省荷泽市',
      '371728': '山东省荷泽市',
      '372300': '山东省滨州市',
      '372301': '山东省滨州市',
      '372321': '山东省滨州市',
      '372323': '山东省滨州市',
      '372324': '山东省滨州市',
      '372325': '山东省滨州市',
      '372328': '山东省滨州市',
      '372330': '山东省滨州市',
      '372900': '山东省荷泽市',
      '372901': '山东省荷泽市',
      '372922': '山东省荷泽市',
      '372923': '山东省荷泽市',
      '372924': '山东省荷泽市',
      '372925': '山东省荷泽市',
      '372926': '山东省荷泽市',
      '372928': '山东省荷泽市',
      '372929': '山东省荷泽市',
      '372930': '山东省荷泽市',
      '410000': '河南省',
      '410100': '河南省郑州市',
      '410101': '河南省郑州市',
      '410102': '河南省郑州市',
      '410103': '河南省郑州市',
      '410104': '河南省郑州市',
      '410105': '河南省郑州市',
      '410106': '河南省郑州市',
      '410108': '河南省郑州市',
      '410122': '河南省郑州市',
      '410181': '河南省郑州市',
      '410182': '河南省郑州市',
      '410183': '河南省郑州市',
      '410184': '河南省郑州市',
      '410185': '河南省郑州市',
      '410200': '河南省开封市',
      '410201': '河南省开封市',
      '410202': '河南省开封市',
      '410203': '河南省开封市',
      '410204': '河南省开封市',
      '410205': '河南省开封市',
      '410211': '河南省开封市',
      '410221': '河南省开封市',
      '410222': '河南省开封市',
      '410223': '河南省开封市',
      '410224': '河南省开封市',
      '410225': '河南省开封市',
      '410300': '河南省洛阳市',
      '410301': '河南省洛阳市',
      '410302': '河南省洛阳市',
      '410303': '河南省洛阳市',
      '410304': '河南省洛阳市',
      '410305': '河南省洛阳市',
      '410306': '河南省洛阳市',
      '410307': '河南省洛阳市',
      '410322': '河南省洛阳市',
      '410323': '河南省洛阳市',
      '410324': '河南省洛阳市',
      '410325': '河南省洛阳市',
      '410326': '河南省洛阳市',
      '410327': '河南省洛阳市',
      '410328': '河南省洛阳市',
      '410329': '河南省洛阳市',
      '410381': '河南省洛阳市',
      '410400': '河南省平顶山市',
      '410401': '河南省平顶山市',
      '410402': '河南省平顶山市',
      '410403': '河南省平顶山市',
      '410404': '河南省平顶山市',
      '410411': '河南省平顶山市',
      '410421': '河南省平顶山市',
      '410422': '河南省平顶山市',
      '410423': '河南省平顶山市',
      '410425': '河南省平顶山市',
      '410481': '河南省平顶山市',
      '410482': '河南省平顶山市',
      '410500': '河南省安阳市',
      '410501': '河南省安阳市',
      '410502': '河南省安阳市',
      '410503': '河南省安阳市',
      '410505': '河南省安阳市',
      '410506': '河南省安阳市',
      '410522': '河南省安阳市',
      '410523': '河南省安阳市',
      '410526': '河南省安阳市',
      '410527': '河南省安阳市',
      '410581': '河南省安阳市',
      '410600': '河南省鹤壁市',
      '410601': '河南省鹤壁市',
      '410602': '河南省鹤壁市',
      '410603': '河南省鹤壁市',
      '410611': '河南省鹤壁市',
      '410621': '河南省鹤壁市',
      '410622': '河南省鹤壁市',
      '410700': '河南省新乡市',
      '410701': '河南省新乡市',
      '410702': '河南省新乡市',
      '410703': '河南省新乡市',
      '410704': '河南省新乡市',
      '410711': '河南省新乡市',
      '410721': '河南省新乡市',
      '410724': '河南省新乡市',
      '410725': '河南省新乡市',
      '410726': '河南省新乡市',
      '410727': '河南省新乡市',
      '410728': '河南省新乡市',
      '410781': '河南省新乡市',
      '410782': '河南省新乡市',
      '410800': '河南省焦作市',
      '410801': '河南省焦作市',
      '410802': '河南省焦作市',
      '410803': '河南省焦作市',
      '410804': '河南省焦作市',
      '410811': '河南省焦作市',
      '410821': '河南省焦作市',
      '410822': '河南省焦作市',
      '410823': '河南省焦作市',
      '410825': '河南省焦作市',
      '410881': '河南省焦作市',
      '410882': '河南省焦作市',
      '410883': '河南省焦作市',
      '410900': '河南省濮阳市',
      '410901': '河南省濮阳市',
      '410902': '河南省濮阳市',
      '410922': '河南省濮阳市',
      '410923': '河南省濮阳市',
      '410926': '河南省濮阳市',
      '410927': '河南省濮阳市',
      '410928': '河南省濮阳市',
      '411000': '河南省许昌市',
      '411001': '河南省许昌市',
      '411002': '河南省许昌市',
      '411023': '河南省许昌市',
      '411024': '河南省许昌市',
      '411025': '河南省许昌市',
      '411081': '河南省许昌市',
      '411082': '河南省许昌市',
      '411100': '河南省漯河市',
      '411101': '河南省漯河市',
      '411102': '河南省漯河市',
      '411103': '河南省漯河市',
      '411104': '河南省漯河市',
      '411121': '河南省漯河市',
      '411122': '河南省漯河市',
      '411123': '河南省漯河市',
      '411200': '河南省三门峡市',
      '411201': '河南省三门峡市',
      '411202': '河南省三门峡市',
      '411221': '河南省三门峡市',
      '411222': '河南省三门峡市',
      '411224': '河南省三门峡市',
      '411281': '河南省三门峡市',
      '411282': '河南省三门峡市',
      '411300': '河南省南阳市',
      '411301': '河南省南阳市',
      '411302': '河南省南阳市',
      '411303': '河南省南阳市',
      '411321': '河南省南阳市',
      '411322': '河南省南阳市',
      '411323': '河南省南阳市',
      '411324': '河南省南阳市',
      '411325': '河南省南阳市',
      '411326': '河南省南阳市',
      '411327': '河南省南阳市',
      '411328': '河南省南阳市',
      '411329': '河南省南阳市',
      '411330': '河南省南阳市',
      '411381': '河南省南阳市',
      '411400': '河南省商丘市',
      '411401': '河南省商丘市',
      '411402': '河南省商丘市',
      '411403': '河南省商丘市',
      '411421': '河南省商丘市',
      '411422': '河南省商丘市',
      '411423': '河南省商丘市',
      '411424': '河南省商丘市',
      '411425': '河南省商丘市',
      '411426': '河南省商丘市',
      '411481': '河南省商丘市',
      '411500': '河南省信阳市',
      '411501': '河南省信阳市',
      '411502': '河南省信阳市',
      '411503': '河南省信阳市',
      '411521': '河南省信阳市',
      '411522': '河南省信阳市',
      '411523': '河南省信阳市',
      '411524': '河南省信阳市',
      '411525': '河南省信阳市',
      '411526': '河南省信阳市',
      '411527': '河南省信阳市',
      '411528': '河南省信阳市',
      '411600': '河南省周口市',
      '411601': '河南省周口市',
      '411602': '河南省周口市',
      '411621': '河南省周口市',
      '411622': '河南省周口市',
      '411623': '河南省周口市',
      '411624': '河南省周口市',
      '411625': '河南省周口市',
      '411626': '河南省周口市',
      '411627': '河南省周口市',
      '411628': '河南省周口市',
      '411681': '河南省周口市',
      '411700': '河南省驻马店市',
      '411701': '河南省驻马店市',
      '411702': '河南省驻马店市',
      '411721': '河南省驻马店市',
      '411722': '河南省驻马店市',
      '411723': '河南省驻马店市',
      '411724': '河南省驻马店市',
      '411725': '河南省驻马店市',
      '411726': '河南省驻马店市',
      '411727': '河南省驻马店市',
      '411728': '河南省驻马店市',
      '411729': '河南省驻马店市',
      '412700': '河南省周口市',
      '412701': '河南省周口市',
      '412702': '河南省周口市',
      '412721': '河南省周口市',
      '412722': '河南省周口市',
      '412723': '河南省周口市',
      '412724': '河南省周口市',
      '412725': '河南省周口市',
      '412726': '河南省周口市',
      '412727': '河南省周口市',
      '412728': '河南省周口市',
      '412800': '河南省驻马店市',
      '412801': '河南省驻马店市',
      '412821': '河南省驻马店市',
      '412822': '河南省驻马店市',
      '412823': '河南省驻马店市',
      '412824': '河南省驻马店市',
      '412825': '河南省驻马店市',
      '412826': '河南省驻马店市',
      '412827': '河南省驻马店市',
      '412828': '河南省驻马店市',
      '412829': '河南省驻马店市',
      '420000': '湖北省',
      '420100': '湖北省武汉市',
      '420101': '湖北省武汉市',
      '420102': '湖北省武汉市',
      '420103': '湖北省武汉市',
      '420104': '湖北省武汉市',
      '420105': '湖北省武汉市',
      '420106': '湖北省武汉市',
      '420107': '湖北省武汉市',
      '420111': '湖北省武汉市',
      '420112': '湖北省武汉市',
      '420113': '湖北省武汉市',
      '420114': '湖北省武汉市',
      '420115': '湖北省武汉市',
      '420116': '湖北省武汉市',
      '420117': '湖北省武汉市',
      '420200': '湖北省黄石市',
      '420201': '湖北省黄石市',
      '420202': '湖北省黄石市',
      '420203': '湖北省黄石市',
      '420204': '湖北省黄石市',
      '420205': '湖北省黄石市',
      '420222': '湖北省黄石市',
      '420281': '湖北省黄石市',
      '420300': '湖北省十堰市',
      '420301': '湖北省十堰市',
      '420302': '湖北省十堰市',
      '420303': '湖北省十堰市',
      '420321': '湖北省十堰市',
      '420322': '湖北省十堰市',
      '420323': '湖北省十堰市',
      '420324': '湖北省十堰市',
      '420325': '湖北省十堰市',
      '420381': '湖北省十堰市',
      '420500': '湖北省宜昌市',
      '420501': '湖北省宜昌市',
      '420502': '湖北省宜昌市',
      '420503': '湖北省宜昌市',
      '420504': '湖北省宜昌市',
      '420505': '湖北省宜昌市',
      '420506': '湖北省宜昌市',
      '420525': '湖北省宜昌市',
      '420526': '湖北省宜昌市',
      '420527': '湖北省宜昌市',
      '420528': '湖北省宜昌市',
      '420529': '湖北省宜昌市',
      '420581': '湖北省宜昌市',
      '420582': '湖北省宜昌市',
      '420583': '湖北省宜昌市',
      '420600': '湖北省襄樊市',
      '420601': '湖北省襄樊市',
      '420602': '湖北省襄樊市',
      '420606': '湖北省襄樊市',
      '420607': '湖北省襄樊市',
      '420624': '湖北省襄樊市',
      '420625': '湖北省襄樊市',
      '420626': '湖北省襄樊市',
      '420682': '湖北省襄樊市',
      '420683': '湖北省襄樊市',
      '420684': '湖北省襄樊市',
      '420700': '湖北省鄂州市',
      '420701': '湖北省鄂州市',
      '420702': '湖北省鄂州市',
      '420703': '湖北省鄂州市',
      '420704': '湖北省鄂州市',
      '420800': '湖北省荆门市',
      '420801': '湖北省荆门市',
      '420802': '湖北省荆门市',
      '420804': '湖北省荆门市',
      '420821': '湖北省荆门市',
      '420822': '湖北省荆门市',
      '420881': '湖北省荆门市',
      '420900': '湖北省孝感市',
      '420901': '湖北省孝感市',
      '420902': '湖北省孝感市',
      '420921': '湖北省孝感市',
      '420922': '湖北省孝感市',
      '420923': '湖北省孝感市',
      '420981': '湖北省孝感市',
      '420982': '湖北省孝感市',
      '420983': '湖北省孝感市',
      '420984': '湖北省孝感市',
      '421000': '湖北省荆州市',
      '421001': '湖北省荆州市',
      '421002': '湖北省荆州市',
      '421003': '湖北省荆州市',
      '421022': '湖北省荆州市',
      '421023': '湖北省荆州市',
      '421024': '湖北省荆州市',
      '421081': '湖北省荆州市',
      '421083': '湖北省荆州市',
      '421087': '湖北省荆州市',
      '421100': '湖北省黄冈市',
      '421101': '湖北省黄冈市',
      '421102': '湖北省黄冈市',
      '421121': '湖北省黄冈市',
      '421122': '湖北省黄冈市',
      '421123': '湖北省黄冈市',
      '421124': '湖北省黄冈市',
      '421125': '湖北省黄冈市',
      '421126': '湖北省黄冈市',
      '421127': '湖北省黄冈市',
      '421181': '湖北省黄冈市',
      '421182': '湖北省黄冈市',
      '421200': '湖北省咸宁市',
      '421201': '湖北省咸宁市',
      '421202': '湖北省咸宁市',
      '421221': '湖北省咸宁市',
      '421222': '湖北省咸宁市',
      '421223': '湖北省咸宁市',
      '421224': '湖北省咸宁市',
      '421281': '湖北省咸宁市',
      '421300': '湖北省随州市',
      '421301': '湖北省随州市',
      '421302': '湖北省随州市',
      '421381': '湖北省随州市',
      '422800': '湖北省恩施土家族苗族自治州',
      '422801': '湖北省恩施土家族苗族自治州',
      '422802': '湖北省恩施土家族苗族自治州',
      '422822': '湖北省恩施土家族苗族自治州',
      '422823': '湖北省恩施土家族苗族自治州',
      '422825': '湖北省恩施土家族苗族自治州',
      '422826': '湖北省恩施土家族苗族自治州',
      '422827': '湖北省恩施土家族苗族自治州',
      '422828': '湖北省恩施土家族苗族自治州',
      '429000': '湖北省省直辖行政单位',
      '429001': '湖北省省直辖行政单位',
      '429004': '湖北省省直辖行政单位',
      '429005': '湖北省省直辖行政单位',
      '429006': '湖北省省直辖行政单位',
      '429021': '湖北省省直辖行政单位',
      '430000': '湖南省',
      '430100': '湖南省长沙市',
      '430101': '湖南省长沙市',
      '430102': '湖南省长沙市',
      '430103': '湖南省长沙市',
      '430104': '湖南省长沙市',
      '430105': '湖南省长沙市',
      '430111': '湖南省长沙市',
      '430121': '湖南省长沙市',
      '430122': '湖南省长沙市',
      '430124': '湖南省长沙市',
      '430181': '湖南省长沙市',
      '430200': '湖南省株洲市',
      '430201': '湖南省株洲市',
      '430202': '湖南省株洲市',
      '430203': '湖南省株洲市',
      '430204': '湖南省株洲市',
      '430211': '湖南省株洲市',
      '430221': '湖南省株洲市',
      '430223': '湖南省株洲市',
      '430224': '湖南省株洲市',
      '430225': '湖南省株洲市',
      '430281': '湖南省株洲市',
      '430300': '湖南省湘潭市',
      '430301': '湖南省湘潭市',
      '430302': '湖南省湘潭市',
      '430304': '湖南省湘潭市',
      '430321': '湖南省湘潭市',
      '430381': '湖南省湘潭市',
      '430382': '湖南省湘潭市',
      '430400': '湖南省衡阳市',
      '430401': '湖南省衡阳市',
      '430405': '湖南省衡阳市',
      '430406': '湖南省衡阳市',
      '430407': '湖南省衡阳市',
      '430408': '湖南省衡阳市',
      '430412': '湖南省衡阳市',
      '430421': '湖南省衡阳市',
      '430422': '湖南省衡阳市',
      '430423': '湖南省衡阳市',
      '430424': '湖南省衡阳市',
      '430426': '湖南省衡阳市',
      '430481': '湖南省衡阳市',
      '430482': '湖南省衡阳市',
      '430500': '湖南省邵阳市',
      '430501': '湖南省邵阳市',
      '430502': '湖南省邵阳市',
      '430503': '湖南省邵阳市',
      '430511': '湖南省邵阳市',
      '430521': '湖南省邵阳市',
      '430522': '湖南省邵阳市',
      '430523': '湖南省邵阳市',
      '430524': '湖南省邵阳市',
      '430525': '湖南省邵阳市',
      '430527': '湖南省邵阳市',
      '430528': '湖南省邵阳市',
      '430529': '湖南省邵阳市',
      '430581': '湖南省邵阳市',
      '430600': '湖南省岳阳市',
      '430601': '湖南省岳阳市',
      '430602': '湖南省岳阳市',
      '430603': '湖南省岳阳市',
      '430611': '湖南省岳阳市',
      '430621': '湖南省岳阳市',
      '430623': '湖南省岳阳市',
      '430624': '湖南省岳阳市',
      '430626': '湖南省岳阳市',
      '430681': '湖南省岳阳市',
      '430682': '湖南省岳阳市',
      '430700': '湖南省常德市',
      '430701': '湖南省常德市',
      '430702': '湖南省常德市',
      '430703': '湖南省常德市',
      '430721': '湖南省常德市',
      '430722': '湖南省常德市',
      '430723': '湖南省常德市',
      '430724': '湖南省常德市',
      '430725': '湖南省常德市',
      '430726': '湖南省常德市',
      '430781': '湖南省常德市',
      '430800': '湖南省张家界市',
      '430801': '湖南省张家界市',
      '430802': '湖南省张家界市',
      '430811': '湖南省张家界市',
      '430821': '湖南省张家界市',
      '430822': '湖南省张家界市',
      '430900': '湖南省益阳市',
      '430901': '湖南省益阳市',
      '430902': '湖南省益阳市',
      '430903': '湖南省益阳市',
      '430921': '湖南省益阳市',
      '430922': '湖南省益阳市',
      '430923': '湖南省益阳市',
      '430981': '湖南省益阳市',
      '431000': '湖南省郴州市',
      '431001': '湖南省郴州市',
      '431002': '湖南省郴州市',
      '431003': '湖南省郴州市',
      '431021': '湖南省郴州市',
      '431022': '湖南省郴州市',
      '431023': '湖南省郴州市',
      '431024': '湖南省郴州市',
      '431025': '湖南省郴州市',
      '431026': '湖南省郴州市',
      '431027': '湖南省郴州市',
      '431028': '湖南省郴州市',
      '431081': '湖南省郴州市',
      '431100': '湖南省永州市',
      '431101': '湖南省永州市',
      '431102': '湖南省永州市',
      '431103': '湖南省永州市',
      '431121': '湖南省永州市',
      '431122': '湖南省永州市',
      '431123': '湖南省永州市',
      '431124': '湖南省永州市',
      '431125': '湖南省永州市',
      '431126': '湖南省永州市',
      '431127': '湖南省永州市',
      '431128': '湖南省永州市',
      '431129': '湖南省永州市',
      '431200': '湖南省怀化市',
      '431201': '湖南省怀化市',
      '431202': '湖南省怀化市',
      '431221': '湖南省怀化市',
      '431222': '湖南省怀化市',
      '431223': '湖南省怀化市',
      '431224': '湖南省怀化市',
      '431225': '湖南省怀化市',
      '431226': '湖南省怀化市',
      '431227': '湖南省怀化市',
      '431228': '湖南省怀化市',
      '431229': '湖南省怀化市',
      '431230': '湖南省怀化市',
      '431281': '湖南省怀化市',
      '431300': '湖南省娄底市',
      '431301': '湖南省娄底市',
      '431302': '湖南省娄底市',
      '431321': '湖南省娄底市',
      '431322': '湖南省娄底市',
      '431381': '湖南省娄底市',
      '431382': '湖南省娄底市',
      '433100': '湖南省湘西土家族苗族自治州',
      '433101': '湖南省湘西土家族苗族自治州',
      '433122': '湖南省湘西土家族苗族自治州',
      '433123': '湖南省湘西土家族苗族自治州',
      '433124': '湖南省湘西土家族苗族自治州',
      '433125': '湖南省湘西土家族苗族自治州',
      '433126': '湖南省湘西土家族苗族自治州',
      '433127': '湖南省湘西土家族苗族自治州',
      '433130': '湖南省湘西土家族苗族自治州',
      '440000': '广东省',
      '440100': '广东省广州市',
      '440101': '广东省广州市',
      '440102': '广东省广州市',
      '440103': '广东省广州市',
      '440104': '广东省广州市',
      '440105': '广东省广州市',
      '440106': '广东省广州市',
      '440107': '广东省广州市',
      '440111': '广东省广州市',
      '440112': '广东省广州市',
      '440113': '广东省广州市',
      '440114': '广东省广州市',
      '440115': '广东省广州市',
      '440116': '广东省广州市',
      '440181': '广东省广州市',
      '440182': '广东省广州市',
      '440183': '广东省广州市',
      '440184': '广东省广州市',
      '440200': '广东省韶关市',
      '440201': '广东省韶关市',
      '440202': '广东省韶关市',
      '440203': '广东省韶关市',
      '440204': '广东省韶关市',
      '440205': '广东省韶关市',
      '440221': '广东省韶关市',
      '440222': '广东省韶关市',
      '440224': '广东省韶关市',
      '440229': '广东省韶关市',
      '440232': '广东省韶关市',
      '440233': '广东省韶关市',
      '440281': '广东省韶关市',
      '440282': '广东省韶关市',
      '440300': '广东省深圳市',
      '440301': '广东省深圳市',
      '440303': '广东省深圳市',
      '440304': '广东省深圳市',
      '440305': '广东省深圳市',
      '440306': '广东省深圳市',
      '440307': '广东省深圳市',
      '440308': '广东省深圳市',
      '440400': '广东省珠海市',
      '440401': '广东省珠海市',
      '440402': '广东省珠海市',
      '440403': '广东省珠海市',
      '440404': '广东省珠海市',
      '440500': '广东省汕头市',
      '440501': '广东省汕头市',
      '440506': '广东省汕头市',
      '440507': '广东省汕头市',
      '440508': '广东省汕头市',
      '440509': '广东省汕头市',
      '440510': '广东省汕头市',
      '440511': '广东省汕头市',
      '440512': '广东省汕头市',
      '440513': '广东省汕头市',
      '440514': '广东省汕头市',
      '440515': '广东省汕头市',
      '440523': '广东省汕头市',
      '440582': '广东省汕头市',
      '440583': '广东省汕头市',
      '440600': '广东省佛山市',
      '440601': '广东省佛山市',
      '440604': '广东省佛山市',
      '440605': '广东省佛山市',
      '440606': '广东省佛山市',
      '440607': '广东省佛山市',
      '440608': '广东省佛山市',
      '440700': '广东省江门市',
      '440701': '广东省江门市',
      '440703': '广东省江门市',
      '440704': '广东省江门市',
      '440705': '广东省江门市',
      '440781': '广东省江门市',
      '440783': '广东省江门市',
      '440784': '广东省江门市',
      '440785': '广东省江门市',
      '440800': '广东省湛江市',
      '440801': '广东省湛江市',
      '440802': '广东省湛江市',
      '440803': '广东省湛江市',
      '440804': '广东省湛江市',
      '440811': '广东省湛江市',
      '440823': '广东省湛江市',
      '440825': '广东省湛江市',
      '440881': '广东省湛江市',
      '440882': '广东省湛江市',
      '440883': '广东省湛江市',
      '440900': '广东省茂名市',
      '440901': '广东省茂名市',
      '440902': '广东省茂名市',
      '440903': '广东省茂名市',
      '440923': '广东省茂名市',
      '440981': '广东省茂名市',
      '440982': '广东省茂名市',
      '440983': '广东省茂名市',
      '441200': '广东省肇庆市',
      '441201': '广东省肇庆市',
      '441202': '广东省肇庆市',
      '441203': '广东省肇庆市',
      '441223': '广东省肇庆市',
      '441224': '广东省肇庆市',
      '441225': '广东省肇庆市',
      '441226': '广东省肇庆市',
      '441283': '广东省肇庆市',
      '441284': '广东省肇庆市',
      '441300': '广东省惠州市',
      '441301': '广东省惠州市',
      '441302': '广东省惠州市',
      '441303': '广东省惠州市',
      '441322': '广东省惠州市',
      '441323': '广东省惠州市',
      '441324': '广东省惠州市',
      '441381': '广东省惠州市',
      '441400': '广东省梅州市',
      '441401': '广东省梅州市',
      '441402': '广东省梅州市',
      '441421': '广东省梅州市',
      '441422': '广东省梅州市',
      '441423': '广东省梅州市',
      '441424': '广东省梅州市',
      '441426': '广东省梅州市',
      '441427': '广东省梅州市',
      '441481': '广东省梅州市',
      '441500': '广东省汕尾市',
      '441501': '广东省汕尾市',
      '441502': '广东省汕尾市',
      '441521': '广东省汕尾市',
      '441523': '广东省汕尾市',
      '441581': '广东省汕尾市',
      '441600': '广东省河源市',
      '441601': '广东省河源市',
      '441602': '广东省河源市',
      '441621': '广东省河源市',
      '441622': '广东省河源市',
      '441623': '广东省河源市',
      '441624': '广东省河源市',
      '441625': '广东省河源市',
      '441700': '广东省阳江市',
      '441701': '广东省阳江市',
      '441702': '广东省阳江市',
      '441721': '广东省阳江市',
      '441723': '广东省阳江市',
      '441781': '广东省阳江市',
      '441800': '广东省清远市',
      '441801': '广东省清远市',
      '441802': '广东省清远市',
      '441821': '广东省清远市',
      '441823': '广东省清远市',
      '441825': '广东省清远市',
      '441826': '广东省清远市',
      '441827': '广东省清远市',
      '441881': '广东省清远市',
      '441882': '广东省清远市',
      '441900': '广东省东莞市',
      '442000': '广东省中山市',
      '445100': '广东省潮州市',
      '445101': '广东省潮州市',
      '445102': '广东省潮州市',
      '445121': '广东省潮州市',
      '445122': '广东省潮州市',
      '445200': '广东省揭阳市',
      '445201': '广东省揭阳市',
      '445202': '广东省揭阳市',
      '445221': '广东省揭阳市',
      '445222': '广东省揭阳市',
      '445224': '广东省揭阳市',
      '445281': '广东省揭阳市',
      '445300': '广东省云浮市',
      '445301': '广东省云浮市',
      '445302': '广东省云浮市',
      '445321': '广东省云浮市',
      '445322': '广东省云浮市',
      '445323': '广东省云浮市',
      '445381': '广东省云浮市',
      '450000': '广西壮族自治区',
      '450100': '广西壮族自治区南宁市',
      '450101': '广西壮族自治区南宁市',
      '450102': '广西壮族自治区南宁市',
      '450103': '广西壮族自治区南宁市',
      '450104': '广西壮族自治区南宁市',
      '450105': '广西壮族自治区南宁市',
      '450106': '广西壮族自治区南宁市',
      '450107': '广西壮族自治区南宁市',
      '450108': '广西壮族自治区南宁市',
      '450109': '广西壮族自治区南宁市',
      '450121': '广西壮族自治区南宁市',
      '450122': '广西壮族自治区南宁市',
      '450123': '广西壮族自治区南宁市',
      '450124': '广西壮族自治区南宁市',
      '450125': '广西壮族自治区南宁市',
      '450126': '广西壮族自治区南宁市',
      '450127': '广西壮族自治区南宁市',
      '450200': '广西壮族自治区柳州市',
      '450201': '广西壮族自治区柳州市',
      '450202': '广西壮族自治区柳州市',
      '450203': '广西壮族自治区柳州市',
      '450204': '广西壮族自治区柳州市',
      '450205': '广西壮族自治区柳州市',
      '450221': '广西壮族自治区柳州市',
      '450222': '广西壮族自治区柳州市',
      '450223': '广西壮族自治区柳州市',
      '450224': '广西壮族自治区柳州市',
      '450225': '广西壮族自治区柳州市',
      '450226': '广西壮族自治区柳州市',
      '450300': '广西壮族自治区桂林市',
      '450301': '广西壮族自治区桂林市',
      '450302': '广西壮族自治区桂林市',
      '450303': '广西壮族自治区桂林市',
      '450304': '广西壮族自治区桂林市',
      '450305': '广西壮族自治区桂林市',
      '450311': '广西壮族自治区桂林市',
      '450321': '广西壮族自治区桂林市',
      '450322': '广西壮族自治区桂林市',
      '450323': '广西壮族自治区桂林市',
      '450324': '广西壮族自治区桂林市',
      '450325': '广西壮族自治区桂林市',
      '450326': '广西壮族自治区桂林市',
      '450327': '广西壮族自治区桂林市',
      '450328': '广西壮族自治区桂林市',
      '450329': '广西壮族自治区桂林市',
      '450330': '广西壮族自治区桂林市',
      '450331': '广西壮族自治区桂林市',
      '450332': '广西壮族自治区桂林市',
      '450400': '广西壮族自治区梧州市',
      '450401': '广西壮族自治区梧州市',
      '450403': '广西壮族自治区梧州市',
      '450404': '广西壮族自治区梧州市',
      '450405': '广西壮族自治区梧州市',
      '450411': '广西壮族自治区梧州市',
      '450421': '广西壮族自治区梧州市',
      '450422': '广西壮族自治区梧州市',
      '450423': '广西壮族自治区梧州市',
      '450481': '广西壮族自治区梧州市',
      '450500': '广西壮族自治区北海市',
      '450501': '广西壮族自治区北海市',
      '450502': '广西壮族自治区北海市',
      '450503': '广西壮族自治区北海市',
      '450512': '广西壮族自治区北海市',
      '450521': '广西壮族自治区北海市',
      '450600': '广西壮族自治区防城港市',
      '450601': '广西壮族自治区防城港市',
      '450602': '广西壮族自治区防城港市',
      '450603': '广西壮族自治区防城港市',
      '450621': '广西壮族自治区防城港市',
      '450681': '广西壮族自治区防城港市',
      '450700': '广西壮族自治区钦州市',
      '450701': '广西壮族自治区钦州市',
      '450702': '广西壮族自治区钦州市',
      '450703': '广西壮族自治区钦州市',
      '450721': '广西壮族自治区钦州市',
      '450722': '广西壮族自治区钦州市',
      '450800': '广西壮族自治区贵港市',
      '450801': '广西壮族自治区贵港市',
      '450802': '广西壮族自治区贵港市',
      '450803': '广西壮族自治区贵港市',
      '450804': '广西壮族自治区贵港市',
      '450821': '广西壮族自治区贵港市',
      '450881': '广西壮族自治区贵港市',
      '450900': '广西壮族自治区玉林市',
      '450901': '广西壮族自治区玉林市',
      '450902': '广西壮族自治区玉林市',
      '450921': '广西壮族自治区玉林市',
      '450922': '广西壮族自治区玉林市',
      '450923': '广西壮族自治区玉林市',
      '450924': '广西壮族自治区玉林市',
      '450981': '广西壮族自治区玉林市',
      '451000': '广西壮族自治区百色市',
      '451001': '广西壮族自治区百色市',
      '451002': '广西壮族自治区百色市',
      '451021': '广西壮族自治区百色市',
      '451022': '广西壮族自治区百色市',
      '451023': '广西壮族自治区百色市',
      '451024': '广西壮族自治区百色市',
      '451025': '广西壮族自治区百色市',
      '451026': '广西壮族自治区百色市',
      '451027': '广西壮族自治区百色市',
      '451028': '广西壮族自治区百色市',
      '451029': '广西壮族自治区百色市',
      '451030': '广西壮族自治区百色市',
      '451031': '广西壮族自治区百色市',
      '451100': '广西壮族自治区贺州市',
      '451101': '广西壮族自治区贺州市',
      '451102': '广西壮族自治区贺州市',
      '451121': '广西壮族自治区贺州市',
      '451122': '广西壮族自治区贺州市',
      '451123': '广西壮族自治区贺州市',
      '451200': '广西壮族自治区河池市',
      '451201': '广西壮族自治区河池市',
      '451202': '广西壮族自治区河池市',
      '451221': '广西壮族自治区河池市',
      '451222': '广西壮族自治区河池市',
      '451223': '广西壮族自治区河池市',
      '451224': '广西壮族自治区河池市',
      '451225': '广西壮族自治区河池市',
      '451226': '广西壮族自治区河池市',
      '451227': '广西壮族自治区河池市',
      '451228': '广西壮族自治区河池市',
      '451229': '广西壮族自治区河池市',
      '451281': '广西壮族自治区河池市',
      '451300': '广西壮族自治区来宾市',
      '451301': '广西壮族自治区来宾市',
      '451302': '广西壮族自治区来宾市',
      '451321': '广西壮族自治区来宾市',
      '451322': '广西壮族自治区来宾市',
      '451323': '广西壮族自治区来宾市',
      '451324': '广西壮族自治区来宾市',
      '451381': '广西壮族自治区来宾市',
      '451400': '广西壮族自治区崇左市',
      '451401': '广西壮族自治区崇左市',
      '451402': '广西壮族自治区崇左市',
      '451421': '广西壮族自治区崇左市',
      '451422': '广西壮族自治区崇左市',
      '451423': '广西壮族自治区崇左市',
      '451424': '广西壮族自治区崇左市',
      '451425': '广西壮族自治区崇左市',
      '451481': '广西壮族自治区崇左市',
      '460000': '海南省',
      '460100': '海南省海口市',
      '460101': '海南省海口市',
      '460105': '海南省海口市',
      '460106': '海南省海口市',
      '460107': '海南省海口市',
      '460108': '海南省海口市',
      '460200': '海南省三亚市',
      '460201': '海南省三亚市',
      '469000': '海南省省直辖县级行政单位',
      '469001': '海南省省直辖县级行政单位',
      '469002': '海南省省直辖县级行政单位',
      '469003': '海南省省直辖县级行政单位',
      '469005': '海南省省直辖县级行政单位',
      '469006': '海南省省直辖县级行政单位',
      '469007': '海南省省直辖县级行政单位',
      '469025': '海南省省直辖县级行政单位',
      '469026': '海南省省直辖县级行政单位',
      '469027': '海南省省直辖县级行政单位',
      '469028': '海南省省直辖县级行政单位',
      '469030': '海南省省直辖县级行政单位',
      '469031': '海南省省直辖县级行政单位',
      '469033': '海南省省直辖县级行政单位',
      '469034': '海南省省直辖县级行政单位',
      '469035': '海南省省直辖县级行政单位',
      '469036': '海南省省直辖县级行政单位',
      '469037': '海南省省直辖县级行政单位',
      '469038': '海南省省直辖县级行政单位',
      '469039': '海南省省直辖县级行政单位',
      '500000': '重庆市',
      '500100': '重庆市重庆市',
      '500101': '重庆市重庆市',
      '500102': '重庆市重庆市',
      '500103': '重庆市重庆市',
      '500104': '重庆市重庆市',
      '500105': '重庆市重庆市',
      '500106': '重庆市重庆市',
      '500107': '重庆市重庆市',
      '500108': '重庆市重庆市',
      '500109': '重庆市重庆市',
      '500110': '重庆市重庆市',
      '500111': '重庆市重庆市',
      '500112': '重庆市重庆市',
      '500113': '重庆市重庆市',
      '500114': '重庆市重庆市',
      '500115': '重庆市重庆市',
      '500200': '重庆市重庆市',
      '500222': '重庆市重庆市',
      '500223': '重庆市重庆市',
      '500224': '重庆市重庆市',
      '500225': '重庆市重庆市',
      '500226': '重庆市重庆市',
      '500227': '重庆市重庆市',
      '500228': '重庆市重庆市',
      '500229': '重庆市重庆市',
      '500230': '重庆市重庆市',
      '500231': '重庆市重庆市',
      '500232': '重庆市重庆市',
      '500233': '重庆市重庆市',
      '500234': '重庆市重庆市',
      '500235': '重庆市重庆市',
      '500236': '重庆市重庆市',
      '500237': '重庆市重庆市',
      '500238': '重庆市重庆市',
      '500239': '重庆市重庆市',
      '500240': '重庆市重庆市',
      '500241': '重庆市重庆市',
      '500242': '重庆市重庆市',
      '500243': '重庆市重庆市',
      '500300': '重庆市重庆市',
      '500381': '重庆市重庆市',
      '500382': '重庆市重庆市',
      '500383': '重庆市重庆市',
      '500384': '重庆市重庆市',
      '510000': '四川省',
      '510100': '四川省成都市',
      '510101': '四川省成都市',
      '510104': '四川省成都市',
      '510105': '四川省成都市',
      '510106': '四川省成都市',
      '510107': '四川省成都市',
      '510108': '四川省成都市',
      '510112': '四川省成都市',
      '510113': '四川省成都市',
      '510114': '四川省成都市',
      '510115': '四川省成都市',
      '510121': '四川省成都市',
      '510122': '四川省成都市',
      '510124': '四川省成都市',
      '510129': '四川省成都市',
      '510131': '四川省成都市',
      '510132': '四川省成都市',
      '510181': '四川省成都市',
      '510182': '四川省成都市',
      '510183': '四川省成都市',
      '510184': '四川省成都市',
      '510300': '四川省自贡市',
      '510301': '四川省自贡市',
      '510302': '四川省自贡市',
      '510303': '四川省自贡市',
      '510304': '四川省自贡市',
      '510311': '四川省自贡市',
      '510321': '四川省自贡市',
      '510322': '四川省自贡市',
      '510400': '四川省攀枝花市',
      '510401': '四川省攀枝花市',
      '510402': '四川省攀枝花市',
      '510403': '四川省攀枝花市',
      '510411': '四川省攀枝花市',
      '510421': '四川省攀枝花市',
      '510422': '四川省攀枝花市',
      '510500': '四川省泸州市',
      '510501': '四川省泸州市',
      '510502': '四川省泸州市',
      '510503': '四川省泸州市',
      '510504': '四川省泸州市',
      '510521': '四川省泸州市',
      '510522': '四川省泸州市',
      '510524': '四川省泸州市',
      '510525': '四川省泸州市',
      '510600': '四川省德阳市',
      '510601': '四川省德阳市',
      '510603': '四川省德阳市',
      '510623': '四川省德阳市',
      '510626': '四川省德阳市',
      '510681': '四川省德阳市',
      '510682': '四川省德阳市',
      '510683': '四川省德阳市',
      '510700': '四川省绵阳市',
      '510701': '四川省绵阳市',
      '510703': '四川省绵阳市',
      '510704': '四川省绵阳市',
      '510722': '四川省绵阳市',
      '510723': '四川省绵阳市',
      '510724': '四川省绵阳市',
      '510725': '四川省绵阳市',
      '510726': '四川省绵阳市',
      '510727': '四川省绵阳市',
      '510781': '四川省绵阳市',
      '510800': '四川省广元市',
      '510801': '四川省广元市',
      '510802': '四川省广元市',
      '510811': '四川省广元市',
      '510812': '四川省广元市',
      '510821': '四川省广元市',
      '510822': '四川省广元市',
      '510823': '四川省广元市',
      '510824': '四川省广元市',
      '510900': '四川省遂宁市',
      '510901': '四川省遂宁市',
      '510902': '四川省遂宁市',
      '510903': '四川省遂宁市',
      '510904': '四川省遂宁市',
      '510921': '四川省遂宁市',
      '510922': '四川省遂宁市',
      '510923': '四川省遂宁市',
      '511000': '四川省内江市',
      '511001': '四川省内江市',
      '511002': '四川省内江市',
      '511011': '四川省内江市',
      '511024': '四川省内江市',
      '511025': '四川省内江市',
      '511028': '四川省内江市',
      '511100': '四川省乐山市',
      '511101': '四川省乐山市',
      '511102': '四川省乐山市',
      '511111': '四川省乐山市',
      '511112': '四川省乐山市',
      '511113': '四川省乐山市',
      '511123': '四川省乐山市',
      '511124': '四川省乐山市',
      '511126': '四川省乐山市',
      '511129': '四川省乐山市',
      '511132': '四川省乐山市',
      '511133': '四川省乐山市',
      '511181': '四川省乐山市',
      '511300': '四川省南充市',
      '511301': '四川省南充市',
      '511302': '四川省南充市',
      '511303': '四川省南充市',
      '511304': '四川省南充市',
      '511321': '四川省南充市',
      '511322': '四川省南充市',
      '511323': '四川省南充市',
      '511324': '四川省南充市',
      '511325': '四川省南充市',
      '511381': '四川省南充市',
      '511400': '四川省眉山市',
      '511401': '四川省眉山市',
      '511402': '四川省眉山市',
      '511421': '四川省眉山市',
      '511422': '四川省眉山市',
      '511423': '四川省眉山市',
      '511424': '四川省眉山市',
      '511425': '四川省眉山市',
      '511500': '四川省宜宾市',
      '511501': '四川省宜宾市',
      '511502': '四川省宜宾市',
      '511521': '四川省宜宾市',
      '511522': '四川省宜宾市',
      '511523': '四川省宜宾市',
      '511524': '四川省宜宾市',
      '511525': '四川省宜宾市',
      '511526': '四川省宜宾市',
      '511527': '四川省宜宾市',
      '511528': '四川省宜宾市',
      '511529': '四川省宜宾市',
      '511600': '四川省广安市',
      '511601': '四川省广安市',
      '511602': '四川省广安市',
      '511621': '四川省广安市',
      '511622': '四川省广安市',
      '511623': '四川省广安市',
      '511681': '四川省广安市',
      '511700': '四川省达州市',
      '511701': '四川省达州市',
      '511702': '四川省达州市',
      '511721': '四川省达州市',
      '511722': '四川省达州市',
      '511723': '四川省达州市',
      '511724': '四川省达州市',
      '511725': '四川省达州市',
      '511781': '四川省达州市',
      '511800': '四川省雅安市',
      '511801': '四川省雅安市',
      '511802': '四川省雅安市',
      '511821': '四川省雅安市',
      '511822': '四川省雅安市',
      '511823': '四川省雅安市',
      '511824': '四川省雅安市',
      '511825': '四川省雅安市',
      '511826': '四川省雅安市',
      '511827': '四川省雅安市',
      '511900': '四川省巴中市',
      '511901': '四川省巴中市',
      '511902': '四川省巴中市',
      '511921': '四川省巴中市',
      '511922': '四川省巴中市',
      '511923': '四川省巴中市',
      '512000': '四川省资阳市',
      '512001': '四川省资阳市',
      '512002': '四川省资阳市',
      '512021': '四川省资阳市',
      '512022': '四川省资阳市',
      '512081': '四川省资阳市',
      '513100': '四川省资阳市',
      '513101': '四川省资阳市',
      '513122': '四川省资阳市',
      '513123': '四川省资阳市',
      '513124': '四川省资阳市',
      '513125': '四川省资阳市',
      '513126': '四川省资阳市',
      '513127': '四川省资阳市',
      '513128': '四川省资阳市',
      '513200': '四川省阿坝藏族羌族自治州',
      '513221': '四川省阿坝藏族羌族自治州',
      '513222': '四川省阿坝藏族羌族自治州',
      '513223': '四川省阿坝藏族羌族自治州',
      '513224': '四川省阿坝藏族羌族自治州',
      '513225': '四川省阿坝藏族羌族自治州',
      '513226': '四川省阿坝藏族羌族自治州',
      '513227': '四川省阿坝藏族羌族自治州',
      '513228': '四川省阿坝藏族羌族自治州',
      '513229': '四川省阿坝藏族羌族自治州',
      '513230': '四川省阿坝藏族羌族自治州',
      '513231': '四川省阿坝藏族羌族自治州',
      '513232': '四川省阿坝藏族羌族自治州',
      '513233': '四川省阿坝藏族羌族自治州',
      '513300': '四川省甘孜藏族自治州',
      '513321': '四川省甘孜藏族自治州',
      '513322': '四川省甘孜藏族自治州',
      '513323': '四川省甘孜藏族自治州',
      '513324': '四川省甘孜藏族自治州',
      '513325': '四川省甘孜藏族自治州',
      '513326': '四川省甘孜藏族自治州',
      '513327': '四川省甘孜藏族自治州',
      '513328': '四川省甘孜藏族自治州',
      '513329': '四川省甘孜藏族自治州',
      '513330': '四川省甘孜藏族自治州',
      '513331': '四川省甘孜藏族自治州',
      '513332': '四川省甘孜藏族自治州',
      '513333': '四川省甘孜藏族自治州',
      '513334': '四川省甘孜藏族自治州',
      '513335': '四川省甘孜藏族自治州',
      '513336': '四川省甘孜藏族自治州',
      '513337': '四川省甘孜藏族自治州',
      '513338': '四川省甘孜藏族自治州',
      '513400': '四川省凉山彝族自治州',
      '513401': '四川省凉山彝族自治州',
      '513422': '四川省凉山彝族自治州',
      '513423': '四川省凉山彝族自治州',
      '513424': '四川省凉山彝族自治州',
      '513425': '四川省凉山彝族自治州',
      '513426': '四川省凉山彝族自治州',
      '513427': '四川省凉山彝族自治州',
      '513428': '四川省凉山彝族自治州',
      '513429': '四川省凉山彝族自治州',
      '513430': '四川省凉山彝族自治州',
      '513431': '四川省凉山彝族自治州',
      '513432': '四川省凉山彝族自治州',
      '513433': '四川省凉山彝族自治州',
      '513434': '四川省凉山彝族自治州',
      '513435': '四川省凉山彝族自治州',
      '513436': '四川省凉山彝族自治州',
      '513437': '四川省凉山彝族自治州',
      '513700': '四川省巴中市',
      '513701': '四川省巴中市',
      '513721': '四川省巴中市',
      '513722': '四川省巴中市',
      '513723': '四川省巴中市',
      '513800': '四川省巴中市',
      '513821': '四川省巴中市',
      '513822': '四川省巴中市',
      '513823': '四川省巴中市',
      '513824': '四川省巴中市',
      '513825': '四川省巴中市',
      '513826': '四川省巴中市',
      '513900': '四川省巴中市',
      '513901': '四川省巴中市',
      '513902': '四川省巴中市',
      '513921': '四川省巴中市',
      '513922': '四川省巴中市',
      '520000': '贵州省',
      '520100': '贵州省贵阳市',
      '520101': '贵州省贵阳市',
      '520102': '贵州省贵阳市',
      '520103': '贵州省贵阳市',
      '520111': '贵州省贵阳市',
      '520112': '贵州省贵阳市',
      '520113': '贵州省贵阳市',
      '520114': '贵州省贵阳市',
      '520121': '贵州省贵阳市',
      '520122': '贵州省贵阳市',
      '520123': '贵州省贵阳市',
      '520181': '贵州省贵阳市',
      '520200': '贵州省六盘水市',
      '520201': '贵州省六盘水市',
      '520203': '贵州省六盘水市',
      '520221': '贵州省六盘水市',
      '520222': '贵州省六盘水市',
      '520300': '贵州省遵义市',
      '520301': '贵州省遵义市',
      '520302': '贵州省遵义市',
      '520303': '贵州省遵义市',
      '520321': '贵州省遵义市',
      '520322': '贵州省遵义市',
      '520323': '贵州省遵义市',
      '520324': '贵州省遵义市',
      '520325': '贵州省遵义市',
      '520326': '贵州省遵义市',
      '520327': '贵州省遵义市',
      '520328': '贵州省遵义市',
      '520329': '贵州省遵义市',
      '520330': '贵州省遵义市',
      '520381': '贵州省遵义市',
      '520382': '贵州省遵义市',
      '520400': '贵州省安顺市',
      '520401': '贵州省安顺市',
      '520402': '贵州省安顺市',
      '520421': '贵州省安顺市',
      '520422': '贵州省安顺市',
      '520423': '贵州省安顺市',
      '520424': '贵州省安顺市',
      '520425': '贵州省安顺市',
      '522200': '贵州省铜仁地区',
      '522201': '贵州省铜仁地区',
      '522222': '贵州省铜仁地区',
      '522223': '贵州省铜仁地区',
      '522224': '贵州省铜仁地区',
      '522225': '贵州省铜仁地区',
      '522226': '贵州省铜仁地区',
      '522227': '贵州省铜仁地区',
      '522228': '贵州省铜仁地区',
      '522229': '贵州省铜仁地区',
      '522230': '贵州省铜仁地区',
      '522300': '贵州省黔西南布依族苗族自治州',
      '522301': '贵州省黔西南布依族苗族自治州',
      '522322': '贵州省黔西南布依族苗族自治州',
      '522323': '贵州省黔西南布依族苗族自治州',
      '522324': '贵州省黔西南布依族苗族自治州',
      '522325': '贵州省黔西南布依族苗族自治州',
      '522326': '贵州省黔西南布依族苗族自治州',
      '522327': '贵州省黔西南布依族苗族自治州',
      '522328': '贵州省黔西南布依族苗族自治州',
      '522400': '贵州省毕节地区',
      '522401': '贵州省毕节地区',
      '522422': '贵州省毕节地区',
      '522423': '贵州省毕节地区',
      '522424': '贵州省毕节地区',
      '522425': '贵州省毕节地区',
      '522426': '贵州省毕节地区',
      '522427': '贵州省毕节地区',
      '522428': '贵州省毕节地区',
      '522500': '贵州省',
      '522501': '贵州省',
      '522526': '贵州省',
      '522527': '贵州省',
      '522528': '贵州省',
      '522529': '贵州省',
      '522530': '贵州省',
      '522600': '贵州省黔东南苗族侗族自治州',
      '522601': '贵州省黔东南苗族侗族自治州',
      '522622': '贵州省黔东南苗族侗族自治州',
      '522623': '贵州省黔东南苗族侗族自治州',
      '522624': '贵州省黔东南苗族侗族自治州',
      '522625': '贵州省黔东南苗族侗族自治州',
      '522626': '贵州省黔东南苗族侗族自治州',
      '522627': '贵州省黔东南苗族侗族自治州',
      '522628': '贵州省黔东南苗族侗族自治州',
      '522629': '贵州省黔东南苗族侗族自治州',
      '522630': '贵州省黔东南苗族侗族自治州',
      '522631': '贵州省黔东南苗族侗族自治州',
      '522632': '贵州省黔东南苗族侗族自治州',
      '522633': '贵州省黔东南苗族侗族自治州',
      '522634': '贵州省黔东南苗族侗族自治州',
      '522635': '贵州省黔东南苗族侗族自治州',
      '522636': '贵州省黔东南苗族侗族自治州',
      '522700': '贵州省黔南布依族苗族自治州',
      '522701': '贵州省黔南布依族苗族自治州',
      '522702': '贵州省黔南布依族苗族自治州',
      '522722': '贵州省黔南布依族苗族自治州',
      '522723': '贵州省黔南布依族苗族自治州',
      '522725': '贵州省黔南布依族苗族自治州',
      '522726': '贵州省黔南布依族苗族自治州',
      '522727': '贵州省黔南布依族苗族自治州',
      '522728': '贵州省黔南布依族苗族自治州',
      '522729': '贵州省黔南布依族苗族自治州',
      '522730': '贵州省黔南布依族苗族自治州',
      '522731': '贵州省黔南布依族苗族自治州',
      '522732': '贵州省黔南布依族苗族自治州',
      '530000': '云南省',
      '530100': '云南省昆明市',
      '530101': '云南省昆明市',
      '530102': '云南省昆明市',
      '530103': '云南省昆明市',
      '530111': '云南省昆明市',
      '530112': '云南省昆明市',
      '530113': '云南省昆明市',
      '530121': '云南省昆明市',
      '530122': '云南省昆明市',
      '530124': '云南省昆明市',
      '530125': '云南省昆明市',
      '530126': '云南省昆明市',
      '530127': '云南省昆明市',
      '530128': '云南省昆明市',
      '530129': '云南省昆明市',
      '530181': '云南省昆明市',
      '530300': '云南省曲靖市',
      '530301': '云南省曲靖市',
      '530302': '云南省曲靖市',
      '530321': '云南省曲靖市',
      '530322': '云南省曲靖市',
      '530323': '云南省曲靖市',
      '530324': '云南省曲靖市',
      '530325': '云南省曲靖市',
      '530326': '云南省曲靖市',
      '530328': '云南省曲靖市',
      '530381': '云南省曲靖市',
      '530400': '云南省玉溪市',
      '530401': '云南省玉溪市',
      '530402': '云南省玉溪市',
      '530421': '云南省玉溪市',
      '530422': '云南省玉溪市',
      '530423': '云南省玉溪市',
      '530424': '云南省玉溪市',
      '530425': '云南省玉溪市',
      '530426': '云南省玉溪市',
      '530427': '云南省玉溪市',
      '530428': '云南省玉溪市',
      '530500': '云南省保山市',
      '530501': '云南省保山市',
      '530502': '云南省保山市',
      '530521': '云南省保山市',
      '530522': '云南省保山市',
      '530523': '云南省保山市',
      '530524': '云南省保山市',
      '530600': '云南省昭通市',
      '530601': '云南省昭通市',
      '530602': '云南省昭通市',
      '530621': '云南省昭通市',
      '530622': '云南省昭通市',
      '530623': '云南省昭通市',
      '530624': '云南省昭通市',
      '530625': '云南省昭通市',
      '530626': '云南省昭通市',
      '530627': '云南省昭通市',
      '530628': '云南省昭通市',
      '530629': '云南省昭通市',
      '530630': '云南省昭通市',
      '530700': '云南省丽江市',
      '530701': '云南省丽江市',
      '530702': '云南省丽江市',
      '530721': '云南省丽江市',
      '530722': '云南省丽江市',
      '530723': '云南省丽江市',
      '530724': '云南省丽江市',
      '530800': '云南省思茅市',
      '530801': '云南省思茅市',
      '530802': '云南省思茅市',
      '530821': '云南省思茅市',
      '530822': '云南省思茅市',
      '530823': '云南省思茅市',
      '530824': '云南省思茅市',
      '530825': '云南省思茅市',
      '530826': '云南省思茅市',
      '530827': '云南省思茅市',
      '530828': '云南省思茅市',
      '530829': '云南省思茅市',
      '530900': '云南省临沧市',
      '530901': '云南省临沧市',
      '530902': '云南省临沧市',
      '530921': '云南省临沧市',
      '530922': '云南省临沧市',
      '530923': '云南省临沧市',
      '530924': '云南省临沧市',
      '530925': '云南省临沧市',
      '530926': '云南省临沧市',
      '530927': '云南省临沧市',
      '532300': '云南省楚雄彝族自治州',
      '532301': '云南省楚雄彝族自治州',
      '532322': '云南省楚雄彝族自治州',
      '532323': '云南省楚雄彝族自治州',
      '532324': '云南省楚雄彝族自治州',
      '532325': '云南省楚雄彝族自治州',
      '532326': '云南省楚雄彝族自治州',
      '532327': '云南省楚雄彝族自治州',
      '532328': '云南省楚雄彝族自治州',
      '532329': '云南省楚雄彝族自治州',
      '532331': '云南省楚雄彝族自治州',
      '532500': '云南省红河哈尼族彝族自治州',
      '532501': '云南省红河哈尼族彝族自治州',
      '532502': '云南省红河哈尼族彝族自治州',
      '532522': '云南省红河哈尼族彝族自治州',
      '532523': '云南省红河哈尼族彝族自治州',
      '532524': '云南省红河哈尼族彝族自治州',
      '532525': '云南省红河哈尼族彝族自治州',
      '532526': '云南省红河哈尼族彝族自治州',
      '532527': '云南省红河哈尼族彝族自治州',
      '532528': '云南省红河哈尼族彝族自治州',
      '532529': '云南省红河哈尼族彝族自治州',
      '532530': '云南省红河哈尼族彝族自治州',
      '532531': '云南省红河哈尼族彝族自治州',
      '532532': '云南省红河哈尼族彝族自治州',
      '532600': '云南省文山壮族苗族自治州',
      '532621': '云南省文山壮族苗族自治州',
      '532622': '云南省文山壮族苗族自治州',
      '532623': '云南省文山壮族苗族自治州',
      '532624': '云南省文山壮族苗族自治州',
      '532625': '云南省文山壮族苗族自治州',
      '532626': '云南省文山壮族苗族自治州',
      '532627': '云南省文山壮族苗族自治州',
      '532628': '云南省文山壮族苗族自治州',
      '532700': '云南省',
      '532701': '云南省',
      '532722': '云南省',
      '532723': '云南省',
      '532724': '云南省',
      '532725': '云南省',
      '532726': '云南省',
      '532727': '云南省',
      '532728': '云南省',
      '532729': '云南省',
      '532730': '云南省',
      '532800': '云南省西双版纳傣族自治州',
      '532801': '云南省西双版纳傣族自治州',
      '532822': '云南省西双版纳傣族自治州',
      '532823': '云南省西双版纳傣族自治州',
      '532900': '云南省大理白族自治州',
      '532901': '云南省大理白族自治州',
      '532922': '云南省大理白族自治州',
      '532923': '云南省大理白族自治州',
      '532924': '云南省大理白族自治州',
      '532925': '云南省大理白族自治州',
      '532926': '云南省大理白族自治州',
      '532927': '云南省大理白族自治州',
      '532928': '云南省大理白族自治州',
      '532929': '云南省大理白族自治州',
      '532930': '云南省大理白族自治州',
      '532931': '云南省大理白族自治州',
      '532932': '云南省大理白族自治州',
      '533100': '云南省德宏傣族景颇族自治州',
      '533102': '云南省德宏傣族景颇族自治州',
      '533103': '云南省德宏傣族景颇族自治州',
      '533122': '云南省德宏傣族景颇族自治州',
      '533123': '云南省德宏傣族景颇族自治州',
      '533124': '云南省德宏傣族景颇族自治州',
      '533300': '云南省怒江傈僳族自治州',
      '533321': '云南省怒江傈僳族自治州',
      '533323': '云南省怒江傈僳族自治州',
      '533324': '云南省怒江傈僳族自治州',
      '533325': '云南省怒江傈僳族自治州',
      '533400': '云南省迪庆藏族自治州',
      '533421': '云南省迪庆藏族自治州',
      '533422': '云南省迪庆藏族自治州',
      '533423': '云南省迪庆藏族自治州',
      '533500': '云南省',
      '533521': '云南省',
      '533522': '云南省',
      '533523': '云南省',
      '533524': '云南省',
      '533525': '云南省',
      '533526': '云南省',
      '533527': '云南省',
      '533528': '云南省',
      '540000': '西藏自治区',
      '540100': '西藏自治区拉萨市',
      '540101': '西藏自治区拉萨市',
      '540102': '西藏自治区拉萨市',
      '540121': '西藏自治区拉萨市',
      '540122': '西藏自治区拉萨市',
      '540123': '西藏自治区拉萨市',
      '540124': '西藏自治区拉萨市',
      '540125': '西藏自治区拉萨市',
      '540126': '西藏自治区拉萨市',
      '540127': '西藏自治区拉萨市',
      '542100': '西藏自治区昌都地区',
      '542121': '西藏自治区昌都地区',
      '542122': '西藏自治区昌都地区',
      '542123': '西藏自治区昌都地区',
      '542124': '西藏自治区昌都地区',
      '542125': '西藏自治区昌都地区',
      '542126': '西藏自治区昌都地区',
      '542127': '西藏自治区昌都地区',
      '542128': '西藏自治区昌都地区',
      '542129': '西藏自治区昌都地区',
      '542132': '西藏自治区昌都地区',
      '542133': '西藏自治区昌都地区',
      '542200': '西藏自治区山南地区',
      '542221': '西藏自治区山南地区',
      '542222': '西藏自治区山南地区',
      '542223': '西藏自治区山南地区',
      '542224': '西藏自治区山南地区',
      '542225': '西藏自治区山南地区',
      '542226': '西藏自治区山南地区',
      '542227': '西藏自治区山南地区',
      '542228': '西藏自治区山南地区',
      '542229': '西藏自治区山南地区',
      '542231': '西藏自治区山南地区',
      '542232': '西藏自治区山南地区',
      '542233': '西藏自治区山南地区',
      '542300': '西藏自治区日喀则地区',
      '542301': '西藏自治区日喀则地区',
      '542322': '西藏自治区日喀则地区',
      '542323': '西藏自治区日喀则地区',
      '542324': '西藏自治区日喀则地区',
      '542325': '西藏自治区日喀则地区',
      '542326': '西藏自治区日喀则地区',
      '542327': '西藏自治区日喀则地区',
      '542328': '西藏自治区日喀则地区',
      '542329': '西藏自治区日喀则地区',
      '542330': '西藏自治区日喀则地区',
      '542331': '西藏自治区日喀则地区',
      '542332': '西藏自治区日喀则地区',
      '542333': '西藏自治区日喀则地区',
      '542334': '西藏自治区日喀则地区',
      '542335': '西藏自治区日喀则地区',
      '542336': '西藏自治区日喀则地区',
      '542337': '西藏自治区日喀则地区',
      '542338': '西藏自治区日喀则地区',
      '542400': '西藏自治区那曲地区',
      '542421': '西藏自治区那曲地区',
      '542422': '西藏自治区那曲地区',
      '542423': '西藏自治区那曲地区',
      '542424': '西藏自治区那曲地区',
      '542425': '西藏自治区那曲地区',
      '542426': '西藏自治区那曲地区',
      '542427': '西藏自治区那曲地区',
      '542428': '西藏自治区那曲地区',
      '542429': '西藏自治区那曲地区',
      '542430': '西藏自治区那曲地区',
      '542500': '西藏自治区阿里地区',
      '542521': '西藏自治区阿里地区',
      '542522': '西藏自治区阿里地区',
      '542523': '西藏自治区阿里地区',
      '542524': '西藏自治区阿里地区',
      '542525': '西藏自治区阿里地区',
      '542526': '西藏自治区阿里地区',
      '542527': '西藏自治区阿里地区',
      '542600': '西藏自治区林芝地区',
      '542621': '西藏自治区林芝地区',
      '542622': '西藏自治区林芝地区',
      '542623': '西藏自治区林芝地区',
      '542624': '西藏自治区林芝地区',
      '542625': '西藏自治区林芝地区',
      '542626': '西藏自治区林芝地区',
      '542627': '西藏自治区林芝地区',
      '610000': '陕西省',
      '610100': '陕西省西安市',
      '610101': '陕西省西安市',
      '610102': '陕西省西安市',
      '610103': '陕西省西安市',
      '610104': '陕西省西安市',
      '610111': '陕西省西安市',
      '610112': '陕西省西安市',
      '610113': '陕西省西安市',
      '610114': '陕西省西安市',
      '610115': '陕西省西安市',
      '610116': '陕西省西安市',
      '610122': '陕西省西安市',
      '610124': '陕西省西安市',
      '610125': '陕西省西安市',
      '610126': '陕西省西安市',
      '610200': '陕西省铜川市',
      '610201': '陕西省铜川市',
      '610202': '陕西省铜川市',
      '610203': '陕西省铜川市',
      '610204': '陕西省铜川市',
      '610222': '陕西省铜川市',
      '610300': '陕西省宝鸡市',
      '610301': '陕西省宝鸡市',
      '610302': '陕西省宝鸡市',
      '610303': '陕西省宝鸡市',
      '610304': '陕西省宝鸡市',
      '610321': '陕西省宝鸡市',
      '610322': '陕西省宝鸡市',
      '610323': '陕西省宝鸡市',
      '610324': '陕西省宝鸡市',
      '610326': '陕西省宝鸡市',
      '610327': '陕西省宝鸡市',
      '610328': '陕西省宝鸡市',
      '610329': '陕西省宝鸡市',
      '610330': '陕西省宝鸡市',
      '610331': '陕西省宝鸡市',
      '610400': '陕西省咸阳市',
      '610401': '陕西省咸阳市',
      '610402': '陕西省咸阳市',
      '610403': '陕西省咸阳市',
      '610404': '陕西省咸阳市',
      '610422': '陕西省咸阳市',
      '610423': '陕西省咸阳市',
      '610424': '陕西省咸阳市',
      '610425': '陕西省咸阳市',
      '610426': '陕西省咸阳市',
      '610427': '陕西省咸阳市',
      '610428': '陕西省咸阳市',
      '610429': '陕西省咸阳市',
      '610430': '陕西省咸阳市',
      '610431': '陕西省咸阳市',
      '610481': '陕西省咸阳市',
      '610500': '陕西省渭南市',
      '610501': '陕西省渭南市',
      '610502': '陕西省渭南市',
      '610521': '陕西省渭南市',
      '610522': '陕西省渭南市',
      '610523': '陕西省渭南市',
      '610524': '陕西省渭南市',
      '610525': '陕西省渭南市',
      '610526': '陕西省渭南市',
      '610527': '陕西省渭南市',
      '610528': '陕西省渭南市',
      '610581': '陕西省渭南市',
      '610582': '陕西省渭南市',
      '610600': '陕西省延安市',
      '610601': '陕西省延安市',
      '610602': '陕西省延安市',
      '610621': '陕西省延安市',
      '610622': '陕西省延安市',
      '610623': '陕西省延安市',
      '610624': '陕西省延安市',
      '610625': '陕西省延安市',
      '610626': '陕西省延安市',
      '610627': '陕西省延安市',
      '610628': '陕西省延安市',
      '610629': '陕西省延安市',
      '610630': '陕西省延安市',
      '610631': '陕西省延安市',
      '610632': '陕西省延安市',
      '610700': '陕西省汉中市',
      '610701': '陕西省汉中市',
      '610702': '陕西省汉中市',
      '610721': '陕西省汉中市',
      '610722': '陕西省汉中市',
      '610723': '陕西省汉中市',
      '610724': '陕西省汉中市',
      '610725': '陕西省汉中市',
      '610726': '陕西省汉中市',
      '610727': '陕西省汉中市',
      '610728': '陕西省汉中市',
      '610729': '陕西省汉中市',
      '610730': '陕西省汉中市',
      '610800': '陕西省榆林市',
      '610801': '陕西省榆林市',
      '610802': '陕西省榆林市',
      '610821': '陕西省榆林市',
      '610822': '陕西省榆林市',
      '610823': '陕西省榆林市',
      '610824': '陕西省榆林市',
      '610825': '陕西省榆林市',
      '610826': '陕西省榆林市',
      '610827': '陕西省榆林市',
      '610828': '陕西省榆林市',
      '610829': '陕西省榆林市',
      '610830': '陕西省榆林市',
      '610831': '陕西省榆林市',
      '610900': '陕西省安康市',
      '610901': '陕西省安康市',
      '610902': '陕西省安康市',
      '610921': '陕西省安康市',
      '610922': '陕西省安康市',
      '610923': '陕西省安康市',
      '610924': '陕西省安康市',
      '610925': '陕西省安康市',
      '610926': '陕西省安康市',
      '610927': '陕西省安康市',
      '610928': '陕西省安康市',
      '610929': '陕西省安康市',
      '611000': '陕西省商洛市',
      '611001': '陕西省商洛市',
      '611002': '陕西省商洛市',
      '611021': '陕西省商洛市',
      '611022': '陕西省商洛市',
      '611023': '陕西省商洛市',
      '611024': '陕西省商洛市',
      '611025': '陕西省商洛市',
      '611026': '陕西省商洛市',
      '612400': '陕西省铜川市',
      '612401': '陕西省铜川市',
      '612422': '陕西省铜川市',
      '612423': '陕西省铜川市',
      '612424': '陕西省铜川市',
      '612425': '陕西省铜川市',
      '612426': '陕西省铜川市',
      '612427': '陕西省铜川市',
      '612428': '陕西省铜川市',
      '612429': '陕西省铜川市',
      '612430': '陕西省铜川市',
      '620000': '甘肃省',
      '620100': '甘肃省兰州市',
      '620101': '甘肃省兰州市',
      '620102': '甘肃省兰州市',
      '620103': '甘肃省兰州市',
      '620104': '甘肃省兰州市',
      '620105': '甘肃省兰州市',
      '620111': '甘肃省兰州市',
      '620121': '甘肃省兰州市',
      '620122': '甘肃省兰州市',
      '620123': '甘肃省兰州市',
      '620200': '甘肃省嘉峪关市',
      '620201': '甘肃省嘉峪关市',
      '620300': '甘肃省金昌市',
      '620301': '甘肃省金昌市',
      '620302': '甘肃省金昌市',
      '620321': '甘肃省金昌市',
      '620400': '甘肃省白银市',
      '620401': '甘肃省白银市',
      '620402': '甘肃省白银市',
      '620403': '甘肃省白银市',
      '620421': '甘肃省白银市',
      '620422': '甘肃省白银市',
      '620423': '甘肃省白银市',
      '620500': '甘肃省天水市',
      '620501': '甘肃省天水市',
      '620502': '甘肃省天水市',
      '620503': '甘肃省天水市',
      '620521': '甘肃省天水市',
      '620522': '甘肃省天水市',
      '620523': '甘肃省天水市',
      '620524': '甘肃省天水市',
      '620525': '甘肃省天水市',
      '620600': '甘肃省武威市',
      '620601': '甘肃省武威市',
      '620602': '甘肃省武威市',
      '620621': '甘肃省武威市',
      '620622': '甘肃省武威市',
      '620623': '甘肃省武威市',
      '620700': '甘肃省张掖市',
      '620701': '甘肃省张掖市',
      '620702': '甘肃省张掖市',
      '620721': '甘肃省张掖市',
      '620722': '甘肃省张掖市',
      '620723': '甘肃省张掖市',
      '620724': '甘肃省张掖市',
      '620725': '甘肃省张掖市',
      '620800': '甘肃省平凉市',
      '620801': '甘肃省平凉市',
      '620802': '甘肃省平凉市',
      '620821': '甘肃省平凉市',
      '620822': '甘肃省平凉市',
      '620823': '甘肃省平凉市',
      '620824': '甘肃省平凉市',
      '620825': '甘肃省平凉市',
      '620826': '甘肃省平凉市',
      '620900': '甘肃省酒泉市',
      '620901': '甘肃省酒泉市',
      '620902': '甘肃省酒泉市',
      '620921': '甘肃省酒泉市',
      '620922': '甘肃省酒泉市',
      '620923': '甘肃省酒泉市',
      '620924': '甘肃省酒泉市',
      '620981': '甘肃省酒泉市',
      '620982': '甘肃省酒泉市',
      '621000': '甘肃省庆阳市',
      '621001': '甘肃省庆阳市',
      '621002': '甘肃省庆阳市',
      '621021': '甘肃省庆阳市',
      '621022': '甘肃省庆阳市',
      '621023': '甘肃省庆阳市',
      '621024': '甘肃省庆阳市',
      '621025': '甘肃省庆阳市',
      '621026': '甘肃省庆阳市',
      '621027': '甘肃省庆阳市',
      '621100': '甘肃省定西市',
      '621101': '甘肃省定西市',
      '621102': '甘肃省定西市',
      '621121': '甘肃省定西市',
      '621122': '甘肃省定西市',
      '621123': '甘肃省定西市',
      '621124': '甘肃省定西市',
      '621125': '甘肃省定西市',
      '621126': '甘肃省定西市',
      '621200': '甘肃省陇南市',
      '621201': '甘肃省陇南市',
      '621202': '甘肃省陇南市',
      '621221': '甘肃省陇南市',
      '621222': '甘肃省陇南市',
      '621223': '甘肃省陇南市',
      '621224': '甘肃省陇南市',
      '621225': '甘肃省陇南市',
      '621226': '甘肃省陇南市',
      '621227': '甘肃省陇南市',
      '621228': '甘肃省陇南市',
      '622400': '甘肃省',
      '622421': '甘肃省',
      '622600': '甘肃省',
      '622621': '甘肃省',
      '622629': '甘肃省',
      '622630': '甘肃省',
      '622900': '甘肃省临夏回族自治州',
      '622901': '甘肃省临夏回族自治州',
      '622921': '甘肃省临夏回族自治州',
      '622922': '甘肃省临夏回族自治州',
      '622923': '甘肃省临夏回族自治州',
      '622924': '甘肃省临夏回族自治州',
      '622925': '甘肃省临夏回族自治州',
      '622926': '甘肃省临夏回族自治州',
      '622927': '甘肃省临夏回族自治州',
      '623000': '甘肃省甘南藏族自治州',
      '623001': '甘肃省甘南藏族自治州',
      '623021': '甘肃省甘南藏族自治州',
      '623022': '甘肃省甘南藏族自治州',
      '623023': '甘肃省甘南藏族自治州',
      '623024': '甘肃省甘南藏族自治州',
      '623025': '甘肃省甘南藏族自治州',
      '623026': '甘肃省甘南藏族自治州',
      '623027': '甘肃省甘南藏族自治州',
      '630000': '青海省',
      '630100': '青海省西宁市',
      '630101': '青海省西宁市',
      '630102': '青海省西宁市',
      '630103': '青海省西宁市',
      '630104': '青海省西宁市',
      '630105': '青海省西宁市',
      '630121': '青海省西宁市',
      '630122': '青海省西宁市',
      '630123': '青海省西宁市',
      '632100': '青海省海东地区',
      '632121': '青海省海东地区',
      '632122': '青海省海东地区',
      '632123': '青海省海东地区',
      '632126': '青海省海东地区',
      '632127': '青海省海东地区',
      '632128': '青海省海东地区',
      '632200': '青海省海北藏族自治州',
      '632221': '青海省海北藏族自治州',
      '632222': '青海省海北藏族自治州',
      '632223': '青海省海北藏族自治州',
      '632224': '青海省海北藏族自治州',
      '632300': '青海省黄南藏族自治州',
      '632321': '青海省黄南藏族自治州',
      '632322': '青海省黄南藏族自治州',
      '632323': '青海省黄南藏族自治州',
      '632324': '青海省黄南藏族自治州',
      '632500': '青海省海南藏族自治州',
      '632521': '青海省海南藏族自治州',
      '632522': '青海省海南藏族自治州',
      '632523': '青海省海南藏族自治州',
      '632524': '青海省海南藏族自治州',
      '632525': '青海省海南藏族自治州',
      '632600': '青海省果洛藏族自治州',
      '632621': '青海省果洛藏族自治州',
      '632622': '青海省果洛藏族自治州',
      '632623': '青海省果洛藏族自治州',
      '632624': '青海省果洛藏族自治州',
      '632625': '青海省果洛藏族自治州',
      '632626': '青海省果洛藏族自治州',
      '632700': '青海省玉树藏族自治州',
      '632721': '青海省玉树藏族自治州',
      '632722': '青海省玉树藏族自治州',
      '632723': '青海省玉树藏族自治州',
      '632724': '青海省玉树藏族自治州',
      '632725': '青海省玉树藏族自治州',
      '632726': '青海省玉树藏族自治州',
      '632800': '青海省海西蒙古族藏族自治州',
      '632801': '青海省海西蒙古族藏族自治州',
      '632802': '青海省海西蒙古族藏族自治州',
      '632821': '青海省海西蒙古族藏族自治州',
      '632822': '青海省海西蒙古族藏族自治州',
      '632823': '青海省海西蒙古族藏族自治州',
      '640000': '宁夏回族自治区',
      '640100': '宁夏回族自治区银川市',
      '640101': '宁夏回族自治区银川市',
      '640104': '宁夏回族自治区银川市',
      '640105': '宁夏回族自治区银川市',
      '640106': '宁夏回族自治区银川市',
      '640121': '宁夏回族自治区银川市',
      '640122': '宁夏回族自治区银川市',
      '640181': '宁夏回族自治区银川市',
      '640200': '宁夏回族自治区石嘴山市',
      '640201': '宁夏回族自治区石嘴山市',
      '640202': '宁夏回族自治区石嘴山市',
      '640203': '宁夏回族自治区石嘴山市',
      '640205': '宁夏回族自治区石嘴山市',
      '640221': '宁夏回族自治区石嘴山市',
      '640222': '宁夏回族自治区',
      '640223': '宁夏回族自治区',
      '640300': '宁夏回族自治区吴忠市',
      '640301': '宁夏回族自治区吴忠市',
      '640302': '宁夏回族自治区吴忠市',
      '640321': '宁夏回族自治区吴忠市',
      '640322': '宁夏回族自治区吴忠市',
      '640323': '宁夏回族自治区吴忠市',
      '640324': '宁夏回族自治区吴忠市',
      '640381': '宁夏回族自治区吴忠市',
      '640400': '宁夏回族自治区固原市',
      '640401': '宁夏回族自治区固原市',
      '640402': '宁夏回族自治区固原市',
      '640421': '宁夏回族自治区固原市',
      '640422': '宁夏回族自治区固原市',
      '640423': '宁夏回族自治区固原市',
      '640424': '宁夏回族自治区固原市',
      '640425': '宁夏回族自治区固原市',
      '640500': '宁夏回族自治区中卫市',
      '640501': '宁夏回族自治区中卫市',
      '640502': '宁夏回族自治区中卫市',
      '640521': '宁夏回族自治区中卫市',
      '640522': '宁夏回族自治区中卫市',
      '650000': '新疆维吾尔自治区',
      '650100': '新疆维吾尔自治区乌鲁木齐市',
      '650101': '新疆维吾尔自治区乌鲁木齐市',
      '650102': '新疆维吾尔自治区乌鲁木齐市',
      '650103': '新疆维吾尔自治区乌鲁木齐市',
      '650104': '新疆维吾尔自治区乌鲁木齐市',
      '650105': '新疆维吾尔自治区乌鲁木齐市',
      '650106': '新疆维吾尔自治区乌鲁木齐市',
      '650107': '新疆维吾尔自治区乌鲁木齐市',
      '650108': '新疆维吾尔自治区乌鲁木齐市',
      '650121': '新疆维吾尔自治区乌鲁木齐市',
      '650200': '新疆维吾尔自治区克拉玛依市',
      '650201': '新疆维吾尔自治区克拉玛依市',
      '650202': '新疆维吾尔自治区克拉玛依市',
      '650203': '新疆维吾尔自治区克拉玛依市',
      '650204': '新疆维吾尔自治区克拉玛依市',
      '650205': '新疆维吾尔自治区克拉玛依市',
      '652100': '新疆维吾尔自治区吐鲁番地区',
      '652101': '新疆维吾尔自治区吐鲁番地区',
      '652122': '新疆维吾尔自治区吐鲁番地区',
      '652123': '新疆维吾尔自治区吐鲁番地区',
      '652200': '新疆维吾尔自治区哈密地区',
      '652201': '新疆维吾尔自治区哈密地区',
      '652222': '新疆维吾尔自治区哈密地区',
      '652223': '新疆维吾尔自治区哈密地区',
      '652300': '新疆维吾尔自治区昌吉回族自治州',
      '652301': '新疆维吾尔自治区昌吉回族自治州',
      '652302': '新疆维吾尔自治区昌吉回族自治州',
      '652303': '新疆维吾尔自治区昌吉回族自治州',
      '652323': '新疆维吾尔自治区昌吉回族自治州',
      '652324': '新疆维吾尔自治区昌吉回族自治州',
      '652325': '新疆维吾尔自治区昌吉回族自治州',
      '652327': '新疆维吾尔自治区昌吉回族自治州',
      '652328': '新疆维吾尔自治区昌吉回族自治州',
      '652700': '新疆维吾尔自治区博尔塔拉蒙古自治州',
      '652701': '新疆维吾尔自治区博尔塔拉蒙古自治州',
      '652722': '新疆维吾尔自治区博尔塔拉蒙古自治州',
      '652723': '新疆维吾尔自治区博尔塔拉蒙古自治州',
      '652800': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652801': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652822': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652823': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652824': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652825': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652826': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652827': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652828': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652829': '新疆维吾尔自治区巴音郭楞蒙古自治州',
      '652900': '新疆维吾尔自治区阿克苏地区',
      '652901': '新疆维吾尔自治区阿克苏地区',
      '652922': '新疆维吾尔自治区阿克苏地区',
      '652923': '新疆维吾尔自治区阿克苏地区',
      '652924': '新疆维吾尔自治区阿克苏地区',
      '652925': '新疆维吾尔自治区阿克苏地区',
      '652926': '新疆维吾尔自治区阿克苏地区',
      '652927': '新疆维吾尔自治区阿克苏地区',
      '652928': '新疆维吾尔自治区阿克苏地区',
      '652929': '新疆维吾尔自治区阿克苏地区',
      '653000': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
      '653001': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
      '653022': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
      '653023': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
      '653024': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
      '653100': '新疆维吾尔自治区喀什地区',
      '653101': '新疆维吾尔自治区喀什地区',
      '653121': '新疆维吾尔自治区喀什地区',
      '653122': '新疆维吾尔自治区喀什地区',
      '653123': '新疆维吾尔自治区喀什地区',
      '653124': '新疆维吾尔自治区喀什地区',
      '653125': '新疆维吾尔自治区喀什地区',
      '653126': '新疆维吾尔自治区喀什地区',
      '653127': '新疆维吾尔自治区喀什地区',
      '653128': '新疆维吾尔自治区喀什地区',
      '653129': '新疆维吾尔自治区喀什地区',
      '653130': '新疆维吾尔自治区喀什地区',
      '653131': '新疆维吾尔自治区喀什地区',
      '653200': '新疆维吾尔自治区和田地区',
      '653201': '新疆维吾尔自治区和田地区',
      '653221': '新疆维吾尔自治区和田地区',
      '653222': '新疆维吾尔自治区和田地区',
      '653223': '新疆维吾尔自治区和田地区',
      '653224': '新疆维吾尔自治区和田地区',
      '653225': '新疆维吾尔自治区和田地区',
      '653226': '新疆维吾尔自治区和田地区',
      '653227': '新疆维吾尔自治区和田地区',
      '654000': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654002': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654003': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654021': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654022': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654023': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654024': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654025': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654026': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654027': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654028': '新疆维吾尔自治区伊犁哈萨克自治州',
      '654200': '新疆维吾尔自治区塔城地区',
      '654201': '新疆维吾尔自治区塔城地区',
      '654202': '新疆维吾尔自治区塔城地区',
      '654221': '新疆维吾尔自治区塔城地区',
      '654223': '新疆维吾尔自治区塔城地区',
      '654224': '新疆维吾尔自治区塔城地区',
      '654225': '新疆维吾尔自治区塔城地区',
      '654226': '新疆维吾尔自治区塔城地区',
      '654300': '新疆维吾尔自治区阿勒泰地区',
      '654301': '新疆维吾尔自治区阿勒泰地区',
      '654321': '新疆维吾尔自治区阿勒泰地区',
      '654322': '新疆维吾尔自治区阿勒泰地区',
      '654323': '新疆维吾尔自治区阿勒泰地区',
      '654324': '新疆维吾尔自治区阿勒泰地区',
      '654325': '新疆维吾尔自治区阿勒泰地区',
      '654326': '新疆维吾尔自治区阿勒泰地区',
      '659000': '新疆维吾尔自治区省直辖行政单位',
      '659001': '新疆维吾尔自治区省直辖行政单位',
      '659002': '新疆维吾尔自治区省直辖行政单位',
      '659003': '新疆维吾尔自治区省直辖行政单位',
      '659004': '新疆维吾尔自治区省直辖行政单位',
      '710000': '台湾省',
      '810000': '香港特别行政区',
      '820000': '澳门特别行政区'
    }
    return cityN[num] ? cityN[num] : '--'
  }
}
